/**
 * シフト共通関数
 *
 * @param {boolean} change_data     編集中フラグ
 * @param {number} move_function    移動先番号
 * @author hayakawa 2025.04.23
 */

// インポート
import {
    $spinner, auto_show_time, auto_hide_time,
    work_plan_type_confirmed, shift_type_nothing, shift_type_clear,
    work_type_delivery_bike, work_type_delivery_car, work_type_delivery_bicycle, work_type_make, work_type_break, work_type_offday, work_type_free,
    option_resizable, option_draggable, alert_messages
} from '../_constants';
import { getAddNow } from '../_functions';
import { movePagefromModal } from '../move_page_from_modal';

// 定数
const $flash_message = $('#flash-message'),                                                         // 実行結果表示場所
    $form_navigation = $('#form-navigation'),                                                       // ナビゲーションフォーム
    $modal_shift = $('#modal-shift'),                                                               // シフトモーダル
    $form_shift = $('#form-shift'),                                                                 // シフトフォーム
    $modal_help_permission = $('#modal-help-permission'),                                           // ヘルプ設定モーダル
    $form_help_permission = $('#form-help-permission'),                                             // ヘルプ設定フォーム
    $form_help_rental = $('#form-help-rental'),                                                     // 他店貸出フォーム
    $modal_help_search = $('#modal-help-search'),                                                   // ヘルプから検索モーダル
    $form_help_search = $('#form-help-search'),                                                     // ヘルプから検索フォーム
    $modal_search_organization = $('#modal-search-organization'),                                   // 店舗検索モーダル
    $modal_alert_at_save = $('#modal-alert-at-save'),                                               // 労務アラートモーダル
    $form_search_organization = $('#form-search-organization'),                                     // 店舗検索フォーム
    $modal_matching_search = $('#modal-matching-search'),                                           // マッチング検索モーダル
    $table_modal_shift = $('table.table-modal-shift'),                                              // シフトテーブル
    $table_dayly = $('table.table-dayly'),                                                          // 日次テーブル
    organization_id = $form_navigation.find('input[type="hidden"][name="organization_id"]').val(),  // 店舗ID
    view_date = $form_navigation.find('input[type="hidden"][name="view_date"]').val(),              // 表示日付
    add_left = 1,                                                                                   // シフトバーの位置調整
    sub_width = 2,                                                                                  // シフトバーの幅調整
    display_start = Number(time_zones[0] + '00'),                                                   // 表示開始時刻
    display_end = Number(time_zones[time_zones.length - 1] + '00');                                 // 表示終了時刻

/**
 * モーダルコンテンツ生成
 *
 * @param {string} employee_id  従業員ID
 * @param {string} work_date    勤務日 (yyyy-mm-dd hh:ii::ss)
 * @param {string} work_plan_id 従業員勤務ID
 * @param {object} from_obj
 * @returns {boolean}
 * @author hayakawa 2023.10.18
 */
export const getContents = (employee_id, work_date, work_plan_id, from_obj) => {
    const params = new URLSearchParams(),
        $btn = $('button'),
        btn_html = from_obj.html();
    let mode = 'div';

    if (from_obj.prop('tagName') === 'BUTTON') {
        mode = 'button';
        $btn.prop('disabled', true);
        from_obj.html($spinner);
    }
    params.append('organization_id', organization_id);
    params.append('employee_id', employee_id);
    params.append('work_date', work_date);
    params.append('work_plan_id', work_plan_id);
    params.append('mode', mode);
    axios.get(`${GET_WORK_PLAN_API_ENDPOINT}?${params.toString()}`)
    .then(res => {
        const data =  res.data,
            employee_name = data.employee_name,
            is_pjcrew = data.is_pjcrew,
            belongs_name = data.belongs_name,
            work_plan = data.work_plan,
            organization_name = data.organization_name,
            work_plan_detail = data.work_plan_detail,
            employee_work_plan = data.employee_work_plan,
            shift_type = data.shift_type,
            is_normal = data.is_normal,
            is_offday = data.is_offday,
            is_free = data.is_free,
            is_help = data.is_help,
            is_help_organization = data.is_help_organization,
            is_help_come = data.is_help_come,
            is_help_go = data.is_help_go,
            can_help_organization_edit = data.can_help_organization_edit,
            is_unsettled = data.is_unsettled,
            is_confirmed = data.is_confirmed,
            is_requested = data.is_requested,
            is_accepted = data.is_accepted,
            default_work_type = data.default_work_type,
            default_work_type_name = data.default_work_type_name,
            work_date_view = data.work_date_view,
            prev_date = data.prev_date,
            next_date = data.next_date,
            update_datetime = data.update_datetime;

        // title
        if (is_help && !can_help_organization_edit) {
            $modal_shift.find('.modal-header').find('h5').text('シフト確認');
        } else if (work_plan === null) {
            $modal_shift.find('.modal-header').find('h5').text('シフト追加');
        } else {
            $modal_shift.find('.modal-header').find('h5').text('シフト修正');
        }

        // button (move)
        $('#btn-move-prev-date').attr('data-date', prev_date);
        $('#btn-move-next-date').attr('data-date', next_date);

        // button (move) 表示制御
        if (is_help_come) {
            $('#btn-move-prev-date, #btn-move-next-date').hide();
        } else {
            $('#btn-move-prev-date, #btn-move-next-date').show();
        }

        // belongs_name
        $('#belongs-name').find('td').text(belongs_name);

        // employee_name
        $('#employee-name').find('td').text(employee_name);

        // default_work_type
        $('#default-work-type').find('td').text(default_work_type_name);

        // work_date
        $('#work-date').find('td').text(work_date_view);

        // shift_type
        $form_shift.find('[name=shift_type]').val((shift_type === shift_type_nothing) ? shift_type_clear : shift_type);
        $('#shift-type-button').find('button').removeClass('active');

        if (is_help_go) {
            $('#shift-type-label').find('td').text(`ヘルプ : ${organization_name}`);
            $('#shift-type-button').hide();
            $('#shift-type-label').show();
            $('#btn-append-tr').closest('tr').hide();
        }else if (is_help_come) {
            $('#shift-type-label').find('td').text('ヘルプ');
            $('#shift-type-button').hide();
            $('#shift-type-label').show();
            $('#btn-append-tr').closest('tr').hide();
        } else {
            if (shift_type === 0) {
                $('#btn-append-tr').closest('tr').hide();
            } else {
                $('#shift-type-button').find(`[data-shift_type=${shift_type}]`).click();
            }
            $('#shift-type-label').hide();
            $('#shift-type-button').show();
        }

        // work_plan_detail
        $table_modal_shift.find('tbody').find('.work-plan-detail').remove();
        $.each(work_plan_detail, function(k, v) {
            cloneWorkPlanDetail(v);
        });

        // work_plan_detail 使用可否
        if (is_help && !can_help_organization_edit) {
            $table_modal_shift.find('tbody').find('.work-plan-detail').find('select, input').prop('disabled', true);
        }

        // button (remove) 表示制御
        if (is_help && !can_help_organization_edit) {
            $table_modal_shift.find('.btn-remove-tr').hide();
        } else {
            $table_modal_shift.find('.btn-remove-tr').show();
        }

        // message (t_work_plan)
        $('#common-message').val((work_plan === null) ? '' : work_plan.message);

        // message (t_employee_work_plan)
        $('#employee-message').val((employee_work_plan === null) ? '' : employee_work_plan.message);

        // message 表示制御、使用可否
        if (is_help) {
            $('#common-message, #employee-message').prop('disabled', true);
            $('#common-message, #employee-message').closest('tr').hide();
        } else if (is_requested || is_accepted) {
            $('#common-message').prop('disabled', false);
            $('#employee-message').prop('disabled', true);
            $('#common-message, #employee-message').closest('tr').show();
        } else {
            $('#common-message').prop('disabled', false);
            $('#employee-message').prop('disabled', true);
            $('#common-message').closest('tr').show();
            $('#employee-message').closest('tr').hide();
        }

        // button (submit) 表示制御
        if (is_help && !can_help_organization_edit) {
            $modal_shift.find('.modal-footer').find('.save').hide();
            $modal_shift.find('.modal-footer').find('.plus').hide();
        } else if (work_plan === null) {
            $modal_shift.find('.modal-footer').find('.save').hide();
            $modal_shift.find('.modal-footer').find('.plus').show();
        } else {
            $modal_shift.find('.modal-footer').find('.save').show();
            $modal_shift.find('.modal-footer').find('.plus').hide();
        }

        // param
        $form_shift.find('[name=work_plan_id]').val((mode === 'div') ? work_plan_id : ((work_plan === null) ? '' : work_plan.work_plan_id));
        $form_shift.find('[name=employee_work_plan_id]').val((employee_work_plan === null) ? '' : employee_work_plan.employee_work_plan_id);
        $form_shift.find('[name=employee_id]').val(employee_id);
        $form_shift.find('[name=organization_id]').val(organization_id);
        $form_shift.find('[name=work_date]').val(work_date);
        $form_shift.find('[name=update_datetime]').val(update_datetime);
        $form_shift.find('[name=default_work_type]').val(default_work_type);

        // モーダル表示
        $form_shift.find('.is-invalid').removeClass('is-invalid');
        $form_shift.find('.invalid-feedback').text('');
        $modal_shift.find('.exec-result-message').empty().hide();
        $modal_shift.modal('show');
    })
    .catch(err => {
        console.log(err)
        alert(err);
    })
    .finally(() => {
        if (from_obj.prop('tagName') === 'BUTTON') {
            from_obj.html(btn_html);
            $btn.prop('disabled', false);
        }
        return true;
    })
}

/**
 * 共通 モーダルコンテンツ 詳細行生成
 *
 * @param {object|false} obj work_plan_detail
 * @returns {boolean}
 * @author hayakawa 2023.10.18
 */
export const cloneWorkPlanDetail = (obj) => {
    const free_start_time = $form_shift.find('[name=free_start_time]').val(),
        free_end_time = $form_shift.find('[name=free_end_time]').val(),
        default_work_type = $form_shift.find('[name=default_work_type]').val(),
        $tr = $('.work-plan-detail.d-none').clone(false);
    let c = $('#btn-append-tr').val();

    $tr.removeClass('d-none');
    $tr.find('select, input').prop('disabled', false);
    if (obj) {
        $tr.find('[name="work_type[]"]').attr('id', `work-type-${c}`).val(obj.work_type).removeClass('placeholder');
        $tr.find('[name="work_time_from[]"]').attr('id', `work-time-from-${c}`).val(obj.work_time_from_hi);
        $tr.find('[name="work_time_to[]"]').attr('id', `work-time-to-${c}`).val(obj.work_time_to_hi);
    } else {
        if (default_work_type) {
            $tr.find('[name="work_type[]"]').attr('id', `work-type-${c}`).val(default_work_type).removeClass('placeholder');
        } else {
            $tr.find('[name="work_type[]"]').attr('id', `work-type-${c}`);
        }
        $tr.find('[name="work_time_from[]"]').attr('id', `work-time-from-${c}`).val(free_start_time);
        $tr.find('[name="work_time_to[]"]').attr('id', `work-time-to-${c}`).val(free_end_time);
    }
    $table_modal_shift.find('tbody').append($tr);
    $('#btn-append-tr').val(Number(c) + 1);
    return true;
}

/**
 * 共通 モーダルコンテンツ 詳細行生成 ※weekly.jsのもの内容は同じ
 *
 * @param {object|false} obj work_plan_detail
 * @returns {boolean}
 * @author hayakawa 2023.10.18
 */
export const cloneWorkPlanDetailForDayly = (obj) => {
    const free_start_time = $form_help_rental.find('[name=free_start_time]').val(),
        free_end_time = $form_help_rental.find('[name=free_end_time]').val(),
        $tr = $('.work-plan-detail.d-none').clone(false);
    let c = $('#btn-append-tr').val();

    $tr.removeClass('d-none');
    $tr.find('select, input').prop('disabled', false);
    if (obj) {
        $tr.find('[name="work_type[]"]').attr('id', `work-type-${c}`).val(obj.work_type).removeClass('placeholder');
        $tr.find('[name="work_time_from[]"]').attr('id', `work-time-from-${c}`).val(obj.work_time_from_hi);
        $tr.find('[name="work_time_to[]"]').attr('id', `work-time-to-${c}`).val(obj.work_time_to_hi);
    } else {
        $tr.find('[name="work_type[]"]').attr('id', `work-type-${c}`).val('');
        $tr.find('[name="work_time_from[]"]').attr('id', `work-time-from-${c}`).val(free_start_time);
        $tr.find('[name="work_time_to[]"]').attr('id', `work-time-to-${c}`).val(free_end_time);
    }
    $table_modal_shift.find('tbody').append($tr);
    $('#btn-append-tr').val(Number(c) + 1);
    return true;
}

/**
 * ヘルプ設定
 *
 * @param {object} obj 対象オブジェクト
 * @param {boolean} first_flag 初回フラグ
 * @returns {void}
 * @author hayakawa 2023.11.30
 */
export const setHelp = (obj, first_flag, edit_flag) => {
    // パラメータ取得
    const $tr = $(obj).closest('tr'),                                                                                                           // tr
        help_request_id = $(obj).attr('data-help_request_id'),                                                                                  // ヘルプ募集ID
        work_time_from = $(obj).attr('data-work_time_from'),                                                                                    // 開始
        work_time_to = $(obj).attr('data-work_time_to'),                                                                                        // 終了
        core_work_from = $(obj).attr('data-core_work_from'),                                                                                    // コアタイム開始
        core_work_to = $(obj).attr('data-core_work_to'),                                                                                        // コアタイム終了
        status = $(obj).attr('data-status'),                                                                                                    // 募集状態
        setting_id = $(obj).attr('data-setting_id'),                                                                                            // 職種ID
        setting_name = $(obj).attr('data-setting_name'),                                                                                        // 職種名
        setting_name_short = $(obj).attr('data-setting_name_short'),                                                                            // 職種名
        work_time_from_hi = $(obj).attr('data-work_time_from_hi'),                                                                              // 開始時分
        work_time_to_hi = $(obj).attr('data-work_time_to_hi'),                                                                                  // 終了時分
        is_recruited = $(obj).attr('data-is_recruited'),                                                                                        // 募集中
        is_negotiated = $(obj).attr('data-is_negotiated'),                                                                                      // 交渉中
        state = $(obj).attr('data-state'),                                                                                                      // 状態
        base_size = $table_dayly.find('.td-help-time').outerWidth(),                                                                            // 1時間の長さ
        half_size = base_size / 2,                                                                                                              // 30分の長さ
        work_time_froms = work_time_from_hi.split(':'),                                                                                         // 時分を分割
        work_time_from_h = String(work_time_froms[0]),                                                                                          // 開始時
        work_time_from_m = String(work_time_froms[1]),                                                                                          // 開始分
        work_time_from_half = (work_time_from_m === '30') ? true : false,                                                                       // 開始が30分か否か
        work_time_tos = work_time_to_hi.split(':'),                                                                                             // 時分を分割
        work_time_to_h = String(work_time_tos[0]),                                                                                              // 終了時
        work_time_to_m = String(work_time_tos[1]),                                                                                              // 終了分
        work_time_to_half = (work_time_to_m === '30') ? true : false,                                                                           // 終了が30分か否か
        work_time_from_index = time_zones.indexOf(work_time_from_h),                                                                            // 開始時Index
        work_time_to_index = time_zones.indexOf(work_time_to_h),                                                                                // 終了時Index
        left_index = (work_time_from_index === -1) ? ((work_time_from_h < time_zones[0]) ? 0 : time_zones.length - 1) : work_time_from_index,   // 開始時Index(表示用)
        right_index = (work_time_to_index === -1) ? ((work_time_to_h < time_zones[0]) ? 0 : time_zones.length - 1) : work_time_to_index,        // 終了時Index(表示用)
        width_index = right_index - left_index;                                                                                                 // 長さIndex
    let left = (left_index) * base_size + add_left,                                                                                             // left(表示用)
        width = width_index * base_size - sub_width;                                                                                            // width(表示用)
    left += ((work_time_from_index !== -1 && work_time_from_half) ? half_size : 0);                                                             // left 開始が30分の場合は加算する
    width -= ((work_time_from_index !== -1 && work_time_from_half) ? half_size : 0);                                                            // width 開始が30分の場合は減算する
    width += ((work_time_to_index !== -1 && work_time_to_index != (time_zones.length - 1) && work_time_to_half) ? half_size : 0);               // width 終了が30分の場合は加算する

    // 位置と長さ
    $(obj).addClass(`work-type-${setting_id}-bg`).css('left', left).css('width', `${width}px`);

    // 表示範囲外の場合
    if ((work_time_from_index === -1 && work_time_to_index === -1) || (left_index === time_zones.length - 1)) {
        $(obj).removeClass('d-flex').addClass('d-none');
    }

    // 職種名
    $(obj).find('.role').text(setting_name_short);
    $(obj).removeClass('justify-content-center');

    // 初回以外
    if (!first_flag) {
        if (edit_flag) {
            // 編集フラグ
            $form_navigation.find('input[type="hidden"][name="shift_edit_flag"]').val(1);
        }

        // In-Out再設定
        setInOutForHelp('table-dayly');
    }
};

/**
 * シフト設定
 *
 * @param {object} obj 対象オブジェクト
 * @param {boolean} first_flag 初回フラグ
 * @param {boolean} edit_flag 編集フラグ
 * @returns {void}
 * @author hayakawa 2023.11.28
 */
export const setShift = (obj, first_flag, edit_flag) => {
    const $tr = $(obj).closest('tr'),                                                                                                           // tr
        is_offday_employee = $tr.attr('data-is_offday_employee'),                                                                               // 休み希望
        help_go = $(obj).attr('data-help_go'),                                                                                                  // ヘルプで他店へ
        organization_name = $(obj).attr('data-organization_name'),                                                                              // 勤務店舗名
        base_size = $table_dayly.find('.td-shift-time').outerWidth(),                                                                           // 1時間の長さ
        half_size = base_size / 2,                                                                                                              // 30分の長さ
        work_type = $(obj).attr('data-work_type'),                                                                                              // 職種
        offday = (work_type === work_type_offday) ? true : false,                                                                               // 休み
        free = (work_type === work_type_free) ? true : false,                                                                                   // フリー
        default_work_type = $(obj).attr('data-default_work_type'),                                                                              // 基本職種
        work_time_from = $(obj).attr('data-work_time_from'),                                                                                    // 開始時分
        work_time_froms = work_time_from.split(':'),                                                                                            // 時分を分割
        work_time_from_h = (offday) ? time_zones[0] : String(work_time_froms[0]),                                                               // 開始時
        work_time_from_m = String(work_time_froms[1]),                                                                                          // 開始分
        work_time_from_half = (work_time_from_m === '30') ? true : false,                                                                       // 開始が30分か否か
        work_time_to = $(obj).attr('data-work_time_to'),                                                                                        // 終了時分
        work_time_tos = work_time_to.split(':'),                                                                                                // 時分を分割
        work_time_to_h = (offday) ? time_zones[time_zones.length - 1] : String(work_time_tos[0]),                                               // 終了時
        work_time_to_m = (offday) ? '00' : String(work_time_tos[1]),                                                                            // 終了分
        work_time_to_half = (work_time_to_m === '30') ? true : false,                                                                           // 終了が30分か否か
        work_time_from_index = time_zones.indexOf(work_time_from_h),                                                                            // 開始時Index
        work_time_to_index = time_zones.indexOf(work_time_to_h),                                                                                // 終了時Index
        left_index = (work_time_from_index === -1) ? ((work_time_from_h < time_zones[0]) ? 0 : time_zones.length - 1) : work_time_from_index,   // 開始時Index(表示用)
        right_index = (work_time_to_index === -1) ? ((work_time_to_h < time_zones[0]) ? 0 : time_zones.length - 1) : work_time_to_index,        // 終了時Index(表示用)
        width_index = right_index - left_index;                                                                                                 // 長さIndex
    let left = (left_index) * base_size + add_left,                                                                                             // left(表示用)
        width = width_index * base_size - sub_width;                                                                                            // width(表示用)

    left += ((work_time_from_index !== -1 && work_time_from_half) ? half_size : 0);                                                             // left 開始が30分の場合は加算する
    width -= ((work_time_from_index !== -1 && work_time_from_half) ? half_size : 0);                                                            // width 開始が30分の場合は減算する
    width += ((work_time_to_index !== -1 && work_time_to_index != (time_zones.length - 1) && work_time_to_half) ? half_size : 0);               // width 終了が30分の場合は加算する

    // 予定シフト
    if (work_type !== '0') {
        if (free) {
            $(obj).addClass(`work-type-${default_work_type}-bg`).css('left', left).css('width', `${width}px`);                                  // 位置と長さ
        } else {
            $(obj).addClass(`work-type-${work_type}-bg`).css('left', left).css('width', `${width}px`);                                          // 位置と長さ
        }
        // 表示範囲外の場合
        if ((work_time_from_index === -1 && work_time_to_index === -1) || (left_index === time_zones.length - 1)) {
            $(obj).removeClass('d-flex').addClass('d-none');
        }
        if (offday) {
            $(obj).find('.role').text((is_offday_employee) ? '休み(本人希望)' : '休み(店舗都合)');
            $(obj).addClass('justify-content-center');
        } else if (free) {
            const work_type_name = work_types[default_work_type];
            $(obj).find('.role').text(work_type_name);
            $(obj).removeClass('justify-content-center');
        } else if (help_go) {
            const work_type_name = work_types[work_type];
            $(obj).addClass(`work-type-help-go-bg`);
            $(obj).find('.role').text(`${work_type_name} (${organization_name})`);
            $(obj).removeClass('justify-content-center');
        } else {
            const work_type_name = work_types[work_type];
            $(obj).find('.role').text(work_type_name);
            $(obj).removeClass('justify-content-center');
        }
        // 初回以外
        if (!first_flag) {
            if (edit_flag) {
                $form_navigation.find('[name=shift_edit_flag]').val(1);
            }
            setInOut('table-dayly');
            setOperationNum('table-dayly', 'table-numbers');
            setLackNum('table-numbers');
            setWorkTimeNum('table-dayly', obj);
        }
    // 希望シフト
    } else {
        const width_e = width - sub_width;                                                                                                      // 長さ
        $(obj).css('left', left + add_left).css('width', `${width_e}px`);                                                                       // 位置と長さ
        // 表示範囲外の場合
        if ((work_time_from_index === -1 && work_time_to_index === -1) || (left_index === time_zones.length - 1)) {
            $(obj).removeClass('d-flex').addClass('d-none');
        }
    }
};

/**
 * リサイズ後処理
 *
 * @param {event} e イベント
 * @param {object} ui UI
 * @returns {void}
 * @author hayakawa 2024.08.21
 */
export const stopResize = (e, ui) => {
    const ui_size_width = ui.size.width,                                                                                // 移動後のwidth
        base_size = $table_dayly.find('.td-shift-time').outerWidth(),                                                   // 1時間の長さ
        half_size = base_size / 2,                                                                                      // 30分の長さ
        quarter_size = half_size / 2,                                                                                   // 15分の長さ
        $target = $(e.target),                                                                                          // 伸縮対象
        $tr = $target.closest('tr'),                                                                                    // tr
        target_is_free = $tr.attr('data-is_free'),                                                                      // free
        target_id = $target.attr('id'),                                                                                 // ID
        target_from = $target.attr('data-work_time_from'),                                                              // 移動前の開始時分
        target_to = $target.attr('data-work_time_to'),                                                                  // 移動前の終了時分
        original_left = ui.originalPosition.left,                                                                       // 移動前のleft
        original_width = ui.originalSize.width,                                                                         // 移動前のwidth
        target_left = ui.position.left,                                                                                 // 移動後のleft
        target_width = $target.outerWidth(),                                                                            // 移動後のwidth
        target_right = target_left + target_width,                                                                      // 移動後のright
        left_quotient = Math.floor(target_left / base_size),                                                            // 開始時Index用
        left_remainder = target_left % base_size,                                                                       // 開始時Index用
        width_quotient = Math.floor((target_width + ((target_from.indexOf('30') !== -1) ? half_size : 0)) / base_size), // 終了時Index用
        width_remainder = target_right % base_size;                                                                     // 終了時Index用
    let new_left_index = left_quotient,                                                                                 // 開始時Index
        new_right_index = left_quotient + width_quotient,                                                               // 終了時Index
        new_left = '',
        new_right = '',
        is_left_half = false,
        is_right_half = false;

    // 左が伸縮した場合
    if (target_left !== original_left) {
        // 余りが45分以上
        if (left_remainder > (half_size + quarter_size)) {
            new_left_index = new_left_index + 1;
            new_left = time_zones[new_left_index] + ':00';
        // 余りが15分以上45分未満
        } else if (left_remainder > quarter_size) {
            is_left_half = true;
            new_left = time_zones[new_left_index] + ':30';
        // その他
        } else {
            new_left = time_zones[new_left_index] + ':00';
        }
        new_right = target_to;
        if (new_left === new_right) {
            new_left = target_from;
        }
    // 右が伸縮した場合
    } else {
        // 余りが45分以上
        if (width_remainder > (half_size + quarter_size)) {
            new_right_index = new_right_index + 1;
            new_right = time_zones[new_right_index] + ':00';
        // 余りが15分以上45分未満
        } else if (width_remainder > quarter_size) {
            is_right_half = true;
            new_right = time_zones[new_right_index] + ':30';
        // その他
        } else {
            new_right = time_zones[new_right_index] + ':00';
        }
        new_left = target_from;
        if (new_right === new_left) {
            new_right = target_to;
        }
    }

    //let resize_done = true;
    let can_exec = true,
        is_overlaped = false,
        overlaped_id = '',
        overlaped_ids = [];

    // 削除
    if (ui_size_width === 1) {
        $target.attr('data-state', 'deleted').removeClass('d-flex').addClass('d-none');
        const live_count = $target.closest('.droppable-area').find('.div-shift-bar').not('[data-state=deleted]').length;
        if (live_count > 0) {
            $tr.attr('data-work_plan_state', 'updated');
        } else {
            $tr.attr('data-work_plan_state', 'deleted');
        }
        setShift($target, false, true);
    // リサイズ
    } else {
        $.when(
            $target.closest('.droppable-area').find('.div-shift-bar').not('.droppable-area-first,.div-shift-bar-employee,[data-state=deleted]').each(function() {
                // 伸縮対象ではない場合
                if ($(this).attr('id') !== target_id) {
                    const left = $(this).position().left,               // left
                        right = left + $(this).width();                 // right

                    // 重なりが発生した場合
                    if (
                        !(target_left < left && target_right < left) &&
                        !(target_left > right && target_right > right)
                    ) {
                        is_overlaped = true;
                        overlaped_ids.push($(this).attr('id'));
                    }
                }
            })
        ).done(function() {
            if (is_overlaped) {
                $.each(overlaped_ids, function(index, val) {
                    const origin_obj = $(`#${val}`),
                        work_plan_id = origin_obj.attr('data-work_plan_id'),
                        update_datetime = origin_obj.attr('data-update_datetime'),
                        organization_id = origin_obj.attr('data-organization_id'),
                        organization_name = origin_obj.attr('data-organization_name'),
                        is_offday = origin_obj.attr('data-is_offday'),
                        is_free = origin_obj.attr('data-is_free'),
                        is_help = origin_obj.attr('data-is_help'),
                        is_help_organization = origin_obj.attr('data-is_help_organization'),
                        help_come = origin_obj.attr('data-help_come'),
                        help_go = origin_obj.attr('data-help_go'),
                        work_type = origin_obj.attr('data-work_type'),
                        work_time_from = origin_obj.attr('data-work_time_from'),
                        work_time_to = origin_obj.attr('data-work_time_to'),
                        work_plan_detail_id = origin_obj.attr('data-work_plan_detail_id'),
                        fixed = origin_obj.attr('data-fixed'),
                        state = origin_obj.attr('data-state'),
                        work_time_froms = work_time_from.split(':'),
                        work_time_from_h = String(work_time_froms[0]),
                        work_time_from_m = String(work_time_froms[1]),
                        work_time_from_half = (work_time_from_m === '30') ? true : false,
                        work_time_tos = work_time_to.split(':'),
                        work_time_to_h = String(work_time_tos[0]),
                        work_time_to_m = String(work_time_tos[1]),
                        work_time_to_half = (work_time_to_m === '30') ? true : false,
                        work_time_from_index = time_zones.indexOf(work_time_from_h),
                        work_time_to_index = time_zones.indexOf(work_time_to_h),
                        left_index = (work_time_from_index === -1) ? ((work_time_from_h < time_zones[0]) ? 0 : time_zones.length - 1) : work_time_from_index,
                        right_index = (work_time_to_index === -1) ? ((work_time_to_h < time_zones[0]) ? 0 : time_zones.length - 1) : work_time_to_index,
                        width_index = right_index - left_index;
                    let is_delete = false;

                    if (is_help) {
                        can_exec = false;
                    } else {
                        // 差し替え
                        if (
                            ((new_left_index === left_index && !(is_left_half && !work_time_from_half)) || new_left_index < left_index) &&
                            ((new_right_index === right_index && !(is_right_half && work_time_from_half)) || new_right_index > right_index)
                        ) {
                            is_delete = true;
                            origin_obj.attr('data-state', 'deleted').removeClass('d-flex').addClass('d-none');
                            $tr.attr('data-work_plan_state', 'updated');
                            setShift(origin_obj, false, true);
                        // 変更
                        } else {
                            // 右だけ残る
                            if ((new_left_index === left_index && !(is_left_half && !work_time_from_half)) || (new_left_index < left_index)) {
                                var new_origin_left_index = new_right_index,
                                    new_origin_right_index = right_index,
                                    new_origin_left = (is_right_half) ? time_zones[new_origin_left_index] + ':30' : time_zones[new_origin_left_index] + ':00',
                                    new_origin_right = (work_time_to_half) ? time_zones[new_origin_right_index] + ':30' : time_zones[new_origin_right_index] + ':00';
                            // 左だけ残る
                            } else {
                                var new_origin_left_index = left_index,
                                    new_origin_right_index = new_left_index,
                                    new_origin_left = (work_time_from_half) ? time_zones[new_origin_left_index] + ':30' : time_zones[new_origin_left_index] + ':00',
                                    new_origin_right = (is_left_half) ? time_zones[new_origin_right_index] + ':30' : time_zones[new_origin_right_index] + ':00';
                            }
                            origin_obj.attr('data-work_time_from', new_origin_left).attr('data-work_time_to', new_origin_right).attr('data-state', 'updated');
                            $tr.attr('data-work_plan_state','updated');
                            setShift(origin_obj, false, true);
                        }
                    }
                });
            }
            if (can_exec) {
                if (target_is_free) {
                    const $div_free = $tr.find(`[data-work_type=${work_type_free}]`),
                        default_work_type = $div_free.attr('data-default_work_type');

                    $target.attr('data-work_time_from', new_left).attr('data-work_time_to', new_right).attr('data-is_free', '').attr('data-work_type', default_work_type).attr('data-state', 'add');
                    $tr.attr('data-is_free', '');
                } else {
                    $target.attr('data-work_time_from', new_left).attr('data-work_time_to', new_right).attr('data-state', 'updated');
                }
                $tr.attr('data-work_plan_state','updated');
                setShift($target, false, true);
            } else {
                alert('シフトが重なっています。');
                $target.css('left', original_left).width(original_width);
            }
            $target.css('z-index', 10).css('opacity', 1);
        });
    }
    change_data = true;
    $('#header-menu-logout').removeAttr('href onclick');
}

/**
 * リサイズ後処理
 *
 * @param {event} e イベント
 * @param {object} ui UI
 * @returns {void}
 * @author hayakawa 2023.11.30
 */
export const stopResizeHelp = (e, ui) => {
    // パラメータ取得
    const ui_size_width = ui.size.width,                                                                                // 移動後のwidth
        base_size = $table_dayly.find('.td-help-time').outerWidth(),                                                    // 1時間の長さ
        half_size = base_size / 2,                                                                                      // 30分の長さ
        quarter_size = half_size / 2,                                                                                   // 15分の長さ
        $target = $(e.target),                                                                                          // 伸縮対象
        $tr = $target.closest('tr'),                                                                                    // tr
        target_id = $target.attr('id'),                                                                                 // ID
        target_from = $target.attr('data-work_time_from_hi'),                                                           // 移動前の開始時分
        target_to = $target.attr('data-work_time_to_hi'),                                                               // 移動前の終了時分
        original_left = ui.originalPosition.left,                                                                       // 移動前のleft
        original_width = ui.originalSize.width,                                                                         // 移動前のwidth
        target_left = ui.position.left,                                                                                 // 移動後のleft
        target_width = $target.outerWidth(),                                                                            // 移動後のwidth
        target_right = target_left + target_width,                                                                      // 移動後のright
        left_quotient = Math.floor(target_left / base_size),                                                            // 開始時Index用
        left_remainder = target_left % base_size,                                                                       // 開始時Index用
        width_quotient = Math.floor((target_width + ((target_from.indexOf('30') !== -1) ? half_size : 0)) / base_size), // 終了時Index用
        width_remainder = target_right % base_size;                                                                     // 終了時Index用
    let new_left_index = left_quotient,                                                                                 // 開始時Index
        new_right_index = left_quotient + width_quotient,                                                               // 終了時Index
        new_left = '',
        new_right = '',
        is_left_half = false,
        is_right_half = false;

    // 左が伸縮した場合
    if (target_left !== original_left) {
        // 余りが45分以上
        if (left_remainder > (half_size + quarter_size)) {
            new_left_index = new_left_index + 1;
            new_left = time_zones[new_left_index] + ':00';
        // 余りが15分以上45分未満
        } else if (left_remainder > quarter_size) {
            is_left_half = true;
            new_left = time_zones[new_left_index] + ':30';
        // その他
        } else {
            new_left = time_zones[new_left_index] + ':00';
        }
        new_right = target_to;
        if (new_left === new_right) {
            new_left = target_from;
        }
    // 右が伸縮した場合
    } else {
        // 余りが45分以上
        if (width_remainder > (half_size + quarter_size)) {
            new_right_index = new_right_index + 1;
            new_right = time_zones[new_right_index] + ':00';
        // 余りが15分以上45分未満
        } else if (width_remainder > quarter_size) {
            is_right_half = true;
            new_right = time_zones[new_right_index] + ':30';
        // その他
        } else {
            new_right = time_zones[new_right_index] + ':00';
        }
        new_left = target_from;
        if (new_right === new_left) {
            new_right = target_to;
        }
    }

    // 削除
    if (ui_size_width === 1) {
        // 削除IDに追加して行ごと削除する
        let deleted_ids = $form_navigation.find('input[type="hidden"][name="deleted_ids"]').val();
        if (deleted_ids === '') {
            deleted_ids = target_id;
        } else {
            deleted_ids = deleted_ids + ',' + target_id;
        }
        $form_navigation.find('input[type="hidden"][name="deleted_ids"]').val(deleted_ids);
        $tr.remove();

    // リサイズ
    } else {
        // パラメータ設定
        $target.attr('data-work_time_from_hi', new_left).attr('data-work_time_to_hi', new_right).attr('data-state', 'updated');
        $tr.attr('data-help_request_state','updated');

        // 再描画
        setHelp($target, false, true);
        $target.css('z-index', 10).css('opacity', 1);
    }

    // 編集中フラグ
    change_data = true;
    $('#header-menu-logout').removeAttr('href onclick');
}

/**
 * 日次 ドラッグ後処理
 *
 * @param {event} e イベント
 * @param {object} ui UI
 * @returns {void}
 * @author hayakawa 2023.11.28
 * @todo 24時間表示などでbase_sizeが極端に小さくなるとブラウザが勝手に数値を設定する為、色々合わなくなってしまう。
 */
export const stopDragg = (e, ui) => {
    const base_size = $table_dayly.find('.td-shift-time').outerWidth(),         // 1時間の長さ
        half_size = base_size / 2,                                              // 30分の長さ
        $target = $(e.target),                                                  // 移動対象
        $tr = $target.closest('tr'),                                            // データ保持用TD
        target_is_free = $tr.attr('data-is_free'),                              // free
        target_id = $target.attr('id'),                                         // ID
        original_left = ui.originalPosition.left,                               // 移動前のleft
        target_left = ui.position.left,                                         // 移動後のleft
        target_width = $target.outerWidth(),                                    // 移動後のwidth
        target_right = target_left + target_width,                              // 移動後のright
        left_quotient = Math.floor((target_left - add_left) / base_size),       // 開始時Index用
        left_remainder = (target_left - add_left) % base_size,                  // 開始30分確認用
        is_left_half = (left_remainder !== 0) ? true :false,
        width_quotient = Math.floor((target_width + sub_width) / base_size),    // 終了時Index用
        width_remainder = (target_width + sub_width) % base_size,               // 終了30分確認用
        is_right_half = ((!is_left_half && width_remainder !== 0) || (is_left_half && width_remainder === 0)) ? true :false,
        new_left_index = left_quotient,                                         // 開始時Index
        new_right_index = left_quotient + width_quotient;                       // 終了時Index
    let can_exec = true,
        is_overlaped = false,
        overlaped_ids = [];

    $.when(
        // Firstと希望以外のDiv繰り返し
        $target.closest('.droppable-area').find('.div-shift-bar').not('.droppable-area-first,.div-shift-bar-employee,[data-state=deleted]').each(function() {
            // 移動対象ではない場合
            if ($(this).attr('id') !== target_id) {
                const left = $(this).position().left,                           // left
                    right = left + $(this).width();                             // right

                // 重なりが発生した場合
                if (
                    !(target_left < left && target_right < left) &&
                    !(target_left > right && target_right > right)
                ) {
                    is_overlaped = true;
                    overlaped_ids.push($(this).attr('id'));
                }
            }
        })
    ).done(function() {
        if (is_overlaped) {
            $.each(overlaped_ids, function(index, val) {
                const origin_obj = $(`#${val}`),
                    work_plan_id = origin_obj.attr('data-work_plan_id'),
                    update_datetime = origin_obj.attr('data-update_datetime'),
                    organization_id = origin_obj.attr('data-organization_id'),
                    organization_name = origin_obj.attr('data-organization_name'),
                    is_offday = origin_obj.attr('data-is_offday'),
                    is_free = origin_obj.attr('data-is_free'),
                    is_help = origin_obj.attr('data-is_help'),
                    is_help_organization = origin_obj.attr('data-is_help_organization'),
                    help_come = origin_obj.attr('data-help_come'),
                    help_go = origin_obj.attr('data-help_go'),
                    work_type = origin_obj.attr('data-work_type'),
                    work_time_from = origin_obj.attr('data-work_time_from'),
                    work_time_to = origin_obj.attr('data-work_time_to'),
                    work_plan_detail_id = origin_obj.attr('data-work_plan_detail_id'),
                    fixed = origin_obj.attr('data-fixed'),
                    state = origin_obj.attr('data-state'),
                    work_time_froms = work_time_from.split(':'),
                    work_time_from_h = String(work_time_froms[0]),
                    work_time_from_m = String(work_time_froms[1]),
                    work_time_from_half = (work_time_from_m === '30') ? true : false,
                    work_time_tos = work_time_to.split(':'),
                    work_time_to_h = String(work_time_tos[0]),
                    work_time_to_m = String(work_time_tos[1]),
                    work_time_to_half = (work_time_to_m === '30') ? true : false,
                    work_time_from_index = time_zones.indexOf(work_time_from_h),
                    work_time_to_index = time_zones.indexOf(work_time_to_h),
                    left_index = (work_time_from_index === -1) ? ((work_time_from_h < time_zones[0]) ? 0 : time_zones.length - 1) : work_time_from_index,
                    right_index = (work_time_to_index === -1) ? ((work_time_to_h < time_zones[0]) ? 0 : time_zones.length - 1) : work_time_to_index,
                    width_index = right_index - left_index;
                let is_delete = false;

                if (is_help) {
                    can_exec = false;
                } else {
                    // 差し替え
                    if (
                        ((new_left_index === left_index && !(is_left_half && !work_time_from_half)) || new_left_index < left_index) &&
                        ((new_right_index === right_index && !(!is_left_half && work_time_from_half)) || new_right_index > right_index)
                    ) {
                        is_delete = true;
                        origin_obj.attr('data-state', 'deleted').removeClass('d-flex').addClass('d-none');
                        $tr.attr('data-work_plan_state', 'updated');
                        setShift(origin_obj, false, true);
                    // 変更
                    } else {
                        // 右だけ残る
                        if ((new_left_index === left_index && !(is_left_half && !work_time_from_half)) || (new_left_index < left_index)) {
                            var new_origin_left_index = new_right_index,
                                new_origin_right_index = right_index,
                                new_origin_left = (is_right_half) ? time_zones[new_origin_left_index] + ':30' : time_zones[new_origin_left_index] + ':00',
                                new_origin_right = (work_time_to_half) ? time_zones[new_origin_right_index] + ':30' : time_zones[new_origin_right_index] + ':00';
                        // 左だけ残る
                        } else {
                            var new_origin_left_index = left_index,
                                new_origin_right_index = new_left_index,
                                new_origin_left = (work_time_from_half) ? time_zones[new_origin_left_index] + ':30' : time_zones[new_origin_left_index] + ':00',
                                new_origin_right = (is_left_half) ? time_zones[new_origin_right_index] + ':30' : time_zones[new_origin_right_index] + ':00';
                        }
                        origin_obj.attr('data-work_time_from', new_origin_left).attr('data-work_time_to', new_origin_right).attr('data-state', 'updated');
                        $tr.attr('data-work_plan_state','updated');
                        setShift(origin_obj, false, true);
                    }

                    // 分割
                    if (
                        !is_delete &&
                        (
                            ((new_left_index === left_index && is_left_half && !work_time_from_half) || new_left_index > left_index) &&
                            ((new_right_index === right_index && !is_right_half && work_time_to_half) || new_right_index < right_index)
                        )
                    ) {
                        const create_count = Number($form_navigation.find('[name=create_count]').val()),
                            work_plan_detail_count = Number($tr.attr('data-work_plan_detail_count')),
                            id = `new-shift-${create_count}`,
                            cls = (time_zones.length > 21) ? 'role text-nowrap fa-sm' : 'role text-nowrap',
                            new_split_left_index = (new_left_index === new_right_index && is_left_half) ? new_right_index + 1 : new_right_index,
                            new_split_right_index = right_index,
                            new_split_left =  (is_right_half) ? time_zones[new_split_left_index] + ':30' : time_zones[new_split_left_index] + ':00',
                            new_split_right =  (work_time_to_half) ? time_zones[new_split_right_index] + ':30' : time_zones[new_split_right_index] + ':00',
                            div = '' +
                            `<div class="div-shift-bar d-flex align-items-center resizable draggable" ` +
                                `id="${id}"\n` +
                                `data-work_plan_id="${work_plan_id}"\n` +
                                `data-update_datetime="${update_datetime}"\n` +
                                `data-organization_id="${organization_id}"\n` +
                                `data-organization_name=""\n` +
                                `data-is_offday=""\n` +
                                `data-is_free=""\n` +
                                `data-is_help=""\n` +
                                `data-is_help_organization=""\n` +
                                `data-help_come=""\n` +
                                `data-help_go=""\n` +
                                `data-work_type="${work_type}"\n` +
                                `data-work_time_from="${new_split_left}"\n` +
                                `data-work_time_to="${new_split_right}"\n` +
                                `data-work_plan_detail_id="0"\n` +
                                `data-fixed=""\n` +
                                `data-state="add">\n` +
                                `<div class="${cls}"></div>\n` +
                            `</div>\n`;

                        // 追加処理
                        $tr.find('.droppable-area').append(div);
                        $tr.attr('data-work_plan_detail_count', work_plan_detail_count + 1).attr('data-work_plan_state', 'updated');
                        $form_navigation.find('[name=create_count]').val(create_count + 1);

                        // 初期処理
                        const split_obj = $(`#${id}`);

                        setShift(split_obj, false, true);
                        $(split_obj).resizable(option_resizable);
                        $(split_obj).draggable(option_draggable);
                    }
                }
            });
        }

        if (can_exec) {
            let new_left = '',
                new_right = '';

            // 開始が00分の場合
            if (left_remainder === 0) {
                new_left = time_zones[new_left_index] + ':00';
                new_right = (width_remainder === half_size) ? time_zones[new_right_index] + ':30' : time_zones[new_right_index] + ':00';
            // 開始が30分の場合
            } else {
                new_left = time_zones[new_left_index] + ':30';
                // 長さが30分の場合は終了時を繰り上げる
                new_right = (width_remainder === half_size) ? time_zones[new_right_index + 1] + ':00' : time_zones[new_right_index] + ':30';
            }

            if (target_is_free) {
                const $div_free = $tr.find(`[data-work_type=${work_type_free}]`),
                    default_work_type = $div_free.attr('data-default_work_type');

                $target.attr('data-work_time_from', new_left).attr('data-work_time_to', new_right).attr('data-is_free', '').attr('data-work_type', default_work_type).attr('data-state', 'add');
                $tr.attr('data-is_free', '');
            } else {
                $target.attr('data-work_time_from', new_left).attr('data-work_time_to', new_right).attr('data-state', 'updated');
            }

            $tr.attr('data-work_plan_state','updated');
            setShift($target, false, true);
            change_data = true;
            $('#header-menu-logout').removeAttr('href onclick');
        } else {
            alert('シフトが重なっています。');
            $target.css('left', original_left);
        }
    });
}

/**
 * 日次 ドラッグ後処理
 *
 * @param {event} e イベント
 * @param {object} ui UI
 * @returns {void}
 * @author hayakawa 2023.11.30
 * @todo 24時間表示などでbase_sizeが極端に小さくなるとブラウザが勝手に数値を設定する為、色々合わなくなってしまう。
 */
export const stopDraggHelp = (e, ui) => {
    // パラメータ取得
    const base_size = $table_dayly.find('.td-help-time').outerWidth(),          // 1時間の長さ
        half_size = base_size / 2,                                              // 30分の長さ
        $target = $(e.target),                                                  // 移動対象
        $tr = $target.closest('tr'),                                            // データ保持用TD
        target_id = $target.attr('id'),                                         // ID
        original_left = ui.originalPosition.left,                               // 移動前のleft
        target_left = ui.position.left,                                         // 移動後のleft
        target_width = $target.outerWidth(),                                    // 移動後のwidth
        target_right = target_left + target_width,                              // 移動後のright
        left_quotient = Math.floor((target_left - add_left) / base_size),       // 開始時Index用
        left_remainder = (target_left - add_left) % base_size,                  // 開始30分確認用
        is_left_half = (left_remainder !== 0) ? true :false,
        width_quotient = Math.floor((target_width + sub_width) / base_size),    // 終了時Index用
        width_remainder = (target_width + sub_width) % base_size,               // 終了30分確認用
        is_right_half = ((!is_left_half && width_remainder !== 0) || (is_left_half && width_remainder === 0)) ? true :false,
        new_left_index = left_quotient,                                         // 開始時Index
        new_right_index = left_quotient + width_quotient;                       // 終了時Index
    let new_left = '',
        new_right = '';

    // 開始が00分の場合
    if (left_remainder === 0) {
        new_left = time_zones[new_left_index] + ':00';
        new_right = (width_remainder === half_size) ? time_zones[new_right_index] + ':30' : time_zones[new_right_index] + ':00';
    // 開始が30分の場合
    } else {
        new_left = time_zones[new_left_index] + ':30';
        // 長さが30分の場合は終了時を繰り上げる
        new_right = (width_remainder === half_size) ? time_zones[new_right_index + 1] + ':00' : time_zones[new_right_index] + ':30';
    }

    // パラメータ設定
    $target.attr('data-work_time_from_hi', new_left).attr('data-work_time_to_hi', new_right).attr('data-state', 'updated');
    $tr.attr('data-help_request_state','updated');

    // 再描画
    setHelp($target, false, true);

    // 編集中フラグ
    change_data = true;
    $('#header-menu-logout').removeAttr('href onclick');
}

/**
 * 日次 InOut設定
 *
 * @param  {string} clsname
 * @returns {void}
 * @author hayakawa 2023.11.24
 */
export const setInOutForHelp = (clsname) => {
    // ヘルプ募集繰り返し
    $(`.${clsname}`).find('tbody').find('tr.tr-help-request').find('div.div-help-bar').each(function() {
        // パラメータ取得
        const $tr = $(this).closest('tr'),
            in_time = $(this).attr('data-work_time_from_hi'),
            in_time_num = Number(in_time.replace(':', '')),
            out_time = $(this).attr('data-work_time_to_hi'),
            out_time_num = Number(out_time.replace(':', '')),
            time_separator = '~';

        // パラメータ設定
        $tr.find('span.in-time').text(in_time);
        $tr.find('span.out-time').text(out_time);
        $tr.find('span.time-separator').text(time_separator);

        // 開始時間が表示範囲外
        if (in_time_num >= display_start && in_time_num <= display_end) {
            $tr.find('span.in-time').removeClass('text-danger');
        } else {
            $tr.find('span.in-time').addClass('text-danger')
        }

        // 終了時間が表示範囲外
        if (out_time_num >= display_start && out_time_num <= display_end) {
            $tr.find('span.out-time').removeClass('text-danger');
        } else {
            $tr.find('span.out-time').addClass('text-danger')
        }
    });
};

/**
 * 日次 InOut設定
 *
 * @param  {string} clsname
 * @returns {void}
 * @author hayakawa 2023.11.24
 */
export const setInOut = (clsname) => {
    // 従業員繰り返し
    $(`.${clsname}`).find('tbody').find('tr.tr-employee').each(function() {
        let in_time = '',
            in_time_num = 0,
            out_time = '',
            out_time_num = 0,
            time_separator = '';

        // シフト繰り返し
        $(this).find('.div-shift-bar').not(`[data-work_type=${work_type_offday}],[data-state=deleted]`).each(function() {
            const work_time_from = $(this).attr('data-work_time_from'),
                work_time_from_num = Number(work_time_from.replace(':', '')),
                work_time_to = $(this).attr('data-work_time_to'),
                work_time_to_num = Number(work_time_to.replace(':', ''));

            if (in_time_num === 0 || in_time_num > work_time_from_num) {
                in_time_num = work_time_from_num;
                in_time = work_time_from;
            }
            if (out_time_num === 0 || out_time_num < work_time_to_num) {
                out_time_num = work_time_to_num;
                out_time = work_time_to;
            }
        });

        if (in_time_num !== 0) {
            time_separator = '~';
        }

        $(this).find('.in-time').text(in_time);
        $(this).find('.out-time').text(out_time);
        $(this).find('.time-separator').text(time_separator);
        if (in_time_num >= display_start && in_time_num <= display_end) {
            $(this).find('.in-time').removeClass('text-danger');
        } else {
            $(this).find('.in-time').addClass('text-danger')
        }
        if (out_time_num >= display_start && out_time_num <= display_end) {
            $(this).find('.out-time').removeClass('text-danger');
        } else {
            $(this).find('.out-time').addClass('text-danger')
        }
    });
};

/**
 * 日次 稼働人数設定
 *
 * @param  {string} clsname1
 * @param  {string} clsname2
 * @returns {void}
 * @author hayakawa 2023.10.18
 */
export const setOperationNum = (clsname1, clsname2) => {
    $(`.${clsname2}`).find('[name^="delivery_operation_num_"]').val(0);
    $(`.${clsname2}`).find('[name^="make_operation_num_"]').val(0);

    // シフト繰り返し
    $(`.${clsname1}`).find('.div-shift-bar').not(`[data-work_type=${work_type_offday}],[data-state=deleted]`).each(function() {
        const free = ($(this).attr('data-work_type') === work_type_free) ? true : false,                    // フリー
            work_type = (free) ? $(this).attr('data-default_work_type') : $(this).attr('data-work_type'),   // 職種 (フリーの場合は基本職種)
            work_time_from = $(this).attr('data-work_time_from'),                                           // 開始時分
            work_time_froms = work_time_from.split(':'),                                                    // 時分を分割
            work_time_from_h = Number(work_time_froms[0]),                                                  // 開始時
            work_time_to = $(this).attr('data-work_time_to'),                                               // 終了時分
            work_time_tos = work_time_to.split(':'),                                                        // 時分を分割
            work_time_to_h = Number(work_time_tos[0]),                                                      // 終了時
            work_organization_id = $(this).attr('data-organization_id');                                    // 勤務店舗ID

        if (work_organization_id === organization_id) {
            // 1:デリバリー（バイク） 10:デリバリー（車） 11:デリバリー（自転車） 2:メイク
            if (work_type === work_type_delivery_bike || work_type === work_type_delivery_car || work_type === work_type_delivery_bicycle || work_type === work_type_make) {
                // 開始時 ~ 終了時
                for (let i = work_time_from_h; i < work_time_to_h; i ++) {
                    const obj_type = (work_type === work_type_delivery_bike || work_type === work_type_delivery_car || work_type === work_type_delivery_bicycle) ? 'delivery_operation_num_' : 'make_operation_num_',
                        obj_idx = (i < 10) ? `0${i}` : i,
                        obj_name = obj_type + obj_idx,
                        obj_val = Number($(`.${clsname2}`).find(`[name=${obj_name}]`).val()) + 1;
                    $(`.${clsname2}`).find(`[name=${obj_name}]`).val(obj_val);
                }
            }
        }
    });
};

/**
 * 日次 不足人数設定
 *
 * @param  {string} clsname
 * @returns {void}
 * @author hayakawa 2023.10.18
 */
export const setLackNum = (clsname) => {
    // 時間帯繰り返し
    $.each(time_zones, function(k, v) {
        const make_appropriate_num = Number($(`.${clsname}`).find(`[name=make_appropriate_num_${v}]`).val()),
            make_operation_num = Number($(`.${clsname}`).find(`[name=make_operation_num_${v}]`).val()),
            make_lack_num = make_operation_num - make_appropriate_num,
            delivery_appropriate_num = Number($(`.${clsname}`).find(`[name=delivery_appropriate_num_${v}]`).val()),
            delivery_operation_num = Number($(`.${clsname}`).find(`[name=delivery_operation_num_${v}]`).val()),
            delivery_lack_num = delivery_operation_num - delivery_appropriate_num;

        if (make_lack_num < 0) {
            $(`.${clsname}`).find(`.make_lack_num_${v}`).text(make_lack_num * -1);
        } else {
            $(`.${clsname}`).find(`.make_lack_num_${v}`).text('');
        }

        if (delivery_lack_num < 0) {
            $(`.${clsname}`).find(`.delivery_lack_num_${v}`).text(delivery_lack_num * -1);
        } else {
            $(`.${clsname}`).find(`.delivery_lack_num_${v}`).text('');
        }
    });
};

/**
 * 日次 労働時間設定
 *
 * @param  {string} clsname
 * @param  {object|null} obj
 * @returns {void}
 * @author hayakawa 2023.11.28
 */
export const setWorkTimeNum = (clsname, obj = null) => {
    const this_day = Number($form_navigation.find('[name=this_day]').val()),                            // 表示日
        last_day_of_month = Number($form_navigation.find('[name=last_day_of_month]').val()),            // 月末日(月の日数)
        free_default_work_time = Number($form_navigation.find('[name=free_default_work_time]').val()),  // フリーの労働時間
        target_employee_id = (obj === null) ? '' : $(obj).closest('tr').attr('data-employee_id');       // チェック対象の従業員ID

    // 従業員繰り返し
    $(`.${clsname}`).find('tbody').find('tr.tr-employee').each(function() {
        const employee_id = $(this).attr('data-employee_id'),                                           // 従業員ID
            is_check = (target_employee_id === employee_id) ? true : false,                             // チェック対象
            is_under_18 = $(this).attr('data-is_under_18'),                                             // 18歳未満
            is_international_student = $(this).attr('data-is_international_student'),                   // 留学生
            is_work_type_manager = $(this).attr('data-is_work_type_manager'),                           // 店長、副店長
            is_work_type_general = $(this).attr('data-is_work_type_general'),                           // 社員
            is_work_type_crew = $(this).attr('data-is_work_type_crew'),                                 // クルー
            week_work_days = Number($(this).attr('data-week_work_days')),                               // 週の労働日数
            week_work_time = Number($(this).attr('data-week_work_time')),                               // 週の労働時間
            week_over_time = Number($(this).attr('data-week_over_time')),                               // 週の残業時間
            month_work_time = Number($(this).attr('data-month_work_time')),                             // 月の労働時間
            month_over_time = Number($(this).attr('data-month_over_time')),                             // 月の残業時間
            last_work_day_of_month = Number($(this).attr('data-last_work_day_of_month')),               // 月の最後の出勤予定日
            this_day_work_time = Number($(this).attr('data-this_day_work_time')),                       // 表示日の労働時間
            this_day_over_time = Number($(this).attr('data-this_day_over_time')),                       // 表示日の残業時間
            count_day = (this_day < last_work_day_of_month) ? last_work_day_of_month : this_day,        // カウント日
            this_count_over_45 = Number($(this).attr('data-this_count_over_45')),                       // 今月の45時間越え回数
            prev_count_over_45 = Number($(this).attr('data-prev_count_over_45')),                       // 先月の45時間越え回数
            is_this_month_over_45 = (this_count_over_45 > prev_count_over_45) ? true : false,           // 今月に45時間超えたか否か
            is_displayed_message = $(this).attr('data-is_displayed_message');                           // メッセージ表示済みフラグ
        let new_this_day_work_time_to_h = 0,                                                            // 表示日の終了時間(新)
            new_this_day_work_time_to_half = false,                                                     // 表示日の終了時間(新)
            new_week_work_days = 0,                                                                     // 週の労働日数(新)
            new_week_work_time = 0,                                                                     // 週の労働時間(新)
            new_week_over_time = 0,                                                                     // 週の残業時間(新)
            new_month_work_time = 0,                                                                    // 月の労働時間(新)
            new_month_over_time = 0,                                                                    // 月の残業時間(新)
            new_this_day_work_time = 0,                                                                 // 表示日の労働時間(新)
            new_this_day_over_time = 0,                                                                 // 表示日の残業時間(新)
            predict_month_work_time = 0,                                                                // 月の予測労働時間
            predict_month_over_time = 0,                                                                // 月の予測残業時間
            new_count_over_45 = 0,                                                                      // 45時間越え回数
            alert_message = '',                                                                         // 警告文
            new_is_displayed_message = is_displayed_message,                                            // メッセージ表示済みフラグ(新)
            message_code = '';                                                                          // メッセージコード

        // シフト繰り返し
        $(this).find('.div-shift-bar').not(`[data-work_type=${work_type_offday}],[data-state=deleted]`).each(function() {
            const work_type = $(this).attr('data-work_type'),                                           // 職種
                work_time_from = $(this).attr('data-work_time_from'),                                   // 開始時分
                work_time_froms = work_time_from.split(':'),                                            // 時分を分割
                work_time_from_h = Number(work_time_froms[0]),                                          // 開始時
                work_time_from_m = Number(work_time_froms[1]),                                          // 開始分
                work_time_from_half = (work_time_from_m === 30) ? true : false,                         // 開始が30分か否か
                work_time_to = $(this).attr('data-work_time_to'),                                       // 終了時分
                work_time_tos = work_time_to.split(':'),                                                // 時分を分割
                work_time_to_h = Number(work_time_tos[0]),                                              // 終了時
                work_time_to_m = Number(work_time_tos[1]),                                              // 終了分
                work_time_to_half = (work_time_to_m === 30) ? true : false;                             // 終了が30分か否か
            let work_time = (work_time_to_h - work_time_from_h);                                        // 終了時 - 開始時

            if (new_this_day_work_time_to_h < work_time_to_h) {
                new_this_day_work_time_to_h = work_time_to_h;
                new_this_day_work_time_to_half = work_time_to_half;
            }
            if (work_time_from_half) {
                work_time -= 0.5;                                                                       // 開始30分 減算
            }
            if (work_time_to_half) {
                work_time += 0.5;                                                                       // 終了30分 加算
            }
            if (work_type === work_type_free) {
                new_this_day_work_time += free_default_work_time;                                       // フリーの場合固定値を加算
            } else if (work_type !== work_type_break) {                                                 // 休憩は除く
                new_this_day_work_time += work_time;
            }
        });

        // 計算
        if (new_this_day_work_time > 8) {
            new_this_day_over_time = new_this_day_work_time - 8;                                        // 当日残業時間
        } else {
            new_this_day_over_time = 0;
        }
        new_week_work_days = week_work_days - ((this_day_work_time > 0) ? 1 : 0) + ((new_this_day_work_time > 0) ? 1 : 0);
        new_week_work_time = week_work_time - this_day_work_time + new_this_day_work_time;
        new_week_over_time = week_over_time - this_day_over_time + new_this_day_over_time;
        new_month_work_time = month_work_time - this_day_work_time + new_this_day_work_time;
        new_month_over_time = month_over_time - this_day_over_time + new_this_day_over_time;
        predict_month_work_time = new_month_work_time * last_day_of_month / count_day;
        predict_month_over_time = new_month_over_time * last_day_of_month / count_day;

        // 設定
        $(this).find('.this-day-work-time').text(formatWorkTime(new_this_day_work_time));
        $(this).find('.week-work-time').text(formatWorkTime(new_week_work_time));
        $(this).find('.predict-month-work-time').text(formatWorkTime(predict_month_work_time));
        $(this).find('.predict-month-over-time').text(formatWorkTime(predict_month_over_time));

        // チェック
        if (is_check) {
            $form_navigation.find('[name=cannot_save_flag]').val(0);
            $('#btn-save-shifts,#btn-lock-shifts').prop('disabled', false).removeClass('disabled');
            // 週7日勤務 チェックは保存時に移行
            /*
            if (new_week_work_days === 7) {
                message_code = 'A';
                if (new_is_displayed_message.indexOf(message_code) === -1) {
                    new_is_displayed_message += message_code;
                    alert_message += `最低でも週1日は休みを取ってください。\n`;
                }
            }
            */
            // 店長・副店長
            if (is_work_type_manager) {
                // 残業週16時間以上又は月80時間以上 チェックは保存時に移行
                /*
                if (new_week_over_time >= 16 || predict_month_over_time >= 80) {
                    message_code = 'B';
                    if (new_is_displayed_message.indexOf(message_code) === -1) {
                        new_is_displayed_message += message_code;
                        alert_message += `残業は長くても週16時間、月80時間未満に設定してください。\n`;
                    }
                }
                */
            }
            // 社員
            if (is_work_type_general) {
                // 残業月25時間以上 チェックは保存時に移行
                /*
                if (predict_month_over_time >= 25) {
                    message_code = 'C';
                    if (new_is_displayed_message.indexOf(message_code) === -1) {
                        new_is_displayed_message += message_code;
                        alert_message += `残業は長くても週5時間、月25時間未満に設定してください。\n`;
                    }
                }
                */
            }
            // クルー
            if (is_work_type_crew) {
                // 残業45時間以上
                if (is_this_month_over_45 || predict_month_over_time >= 45) {
                    new_count_over_45 = (is_this_month_over_45) ? this_count_over_45 : prev_count_over_45 + 1;
                    // 6回目 チェックは保存時に移行
                    /*
                    if (new_count_over_45 === 6) {
                        message_code = 'D';
                        if (new_is_displayed_message.indexOf(message_code) === -1) {
                            new_is_displayed_message += message_code;
                            alert_message += `来月以降45時間以上の残業はできません。\n`;
                        }
                    // 7回目 不可制御が入るのでこのまま！
                    } else
                    */
                    if (new_count_over_45 === 7) {
                        message_code = 'E';
                        if (new_is_displayed_message.indexOf(message_code) === -1) {
                            new_is_displayed_message += message_code;
                            alert_message += `45時間以上の残業はできません。\n`;
                        }
                        $form_navigation.find('[name=cannot_save_flag]').val(1);
                    // その他 チェックは保存時に移行
                    }
                    /*
                    else {
                        message_code = 'F';
                        if (new_is_displayed_message.indexOf(message_code) === -1) {
                            new_is_displayed_message += message_code;
                            alert_message += `45時間以上の残業${new_count_over_45}回目です。\n`;
                        }
                    }
                    */
                }
            }
            // 18歳未満
            if (is_under_18) {
                // 終了が21時台 チェックは保存時に移行
                /*
                if ((new_this_day_work_time_to_h === 21 && new_this_day_work_time_to_half) || (new_this_day_work_time_to_h === 22 && !new_this_day_work_time_to_half)) {
                    message_code = 'G';
                    if (new_is_displayed_message.indexOf(message_code) === -1) {
                        new_is_displayed_message += message_code;
                        alert_message += `18歳未満は21時まで勤務にしましょう。\n`;
                    }
                // 終了が22時以降 不可制御が入るのでこのまま！
                } else
                */
                if ((new_this_day_work_time_to_h === 22 && new_this_day_work_time_to_half) || new_this_day_work_time_to_h > 22) {
                    message_code = 'H';
                    if (new_is_displayed_message.indexOf(message_code) === -1) {
                        new_is_displayed_message += message_code;
                        alert_message += `18歳未満は22時以降の勤務はできません。\n`;
                    }
                    $form_navigation.find('[name=cannot_save_flag]').val(1);
                }
                // 残業あり 不可制御が入るのでこのまま！
                if (new_this_day_over_time > 0) {
                    message_code = 'I';
                    if (new_is_displayed_message.indexOf(message_code) === -1) {
                        new_is_displayed_message += message_code;
                        alert_message += `18歳未満は残業できません。\n`;
                    }
                    $form_navigation.find('[name=cannot_save_flag]').val(1);
                }
            }
            // 留学生
            if (is_international_student) {
                // 週労働時間28時間 不可制御が入るのでこのまま！
                if (new_week_work_time > 28) {
                    message_code = 'J';
                    if (new_is_displayed_message.indexOf(message_code) === -1) {
                        new_is_displayed_message += message_code;
                        alert_message += `留学生は週労働時間28時間までです。\n`;
                    }
                    $form_navigation.find('[name=cannot_save_flag]').val(1);
                }
                // 残業あり 不可制御が入るのでこのまま！
                if (new_this_day_over_time > 0) {
                    message_code = 'K';
                    if (new_is_displayed_message.indexOf(message_code) === -1) {
                        new_is_displayed_message += message_code;
                        alert_message += `留学生は残業できません。\n`;
                    }
                    $form_navigation.find('[name=cannot_save_flag]').val(1);
                }
                // 週7日勤務 ※メッセージは既に追加済み 不可制御が入るのでこのままだが、メッセージ表示を追加する！
                if (new_week_work_days === 7) {
                    message_code = 'A';
                    if (new_is_displayed_message.indexOf(message_code) === -1) {
                        new_is_displayed_message += message_code;
                        alert_message += `最低でも週1日は休みを取ってください。\n`;
                    }
                    $form_navigation.find('[name=cannot_save_flag]').val(1);
                }
            }
            // 不可制御
            if ($form_navigation.find('[name=cannot_save_flag]').val() === '1') {
                $('#btn-save-shifts,#btn-lock-shifts').prop('disabled', true).addClass('disabled');
            }
            // メッセージ表示済みフラグ保存
            $(this).attr('data-is_displayed_message', new_is_displayed_message);
            // メッセージ表示
            if (alert_message !== '') {
                alert(alert_message);
            }
        }
    });
};

/**
 * 日次 労働時間フォーマット
 *
 * @param {number} work_time 労働時間
 * @returns {number|string}
 * @author hayakawa 2023.10.18
 */
export const formatWorkTime = (work_time) => {
    if (work_time === 0) {
        return '';
    } else {
        return Math.round(work_time * 100) / 100;
    }
};

/**
 * 日次 JS用時分フォーマット
 *
 * @param {string} datetime yyy-mm-dd hh:ii:ss
 * @returns {string} hh:ii
 * @author hayakawa 2023.10.18
 */
export const formatDatetimeToHi = (datetime) => {
    return (datetime) ? datetime.substring(11, 16) : '';
};

/**
 * 日次 JS用 パラメータフォーマット
 *
 * @param {any} str
 * @returns {string}
 * @author hayakawa 2023.10.18
 */
export const formatResponseParamToStr = (str) => {
    let ret = '';
    switch (String(str)) {
        case '':
        case '0':
        case 'false':
        case 'null':
        case 'undefined': ret = ''; break;
        case 'true': ret = '1'; break;
        default: ret = String(str); break;
    }
    return ret;
};

/**
 * 日次 一時保存
 *
 * @param {boolean} standalone      trueなら一時保存、falseなら確定
 * @param {object} obj              対象オブジェクト
 * @param {number} work_plan_type   勤務予定時間ステータス (1:確定、0：未確定)
 * @param {boolean} is_alert        trueなら労務アラートモーダルから
 * @returns {void}
 * @author hayakawa 2024.08.07
 */
export const setShiftAll = (standalone, obj, work_plan_type, is_alert) => {
    const params = new URLSearchParams(),
        $btn = $('button'),
        btn_html = $(this).html();

    $btn.prop('disabled', true);
    $(this).html($spinner);
    params.append('view_organization_id', organization_id);
    params.append('ymd', view_date);

    // ヘルプ募集
    let idx = 0;
    $table_dayly.find('tbody').find('tr.tr-help-request').find('div.div-help-bar').each(function() {
        const help_request_id = $(this).attr('data-help_request_id'),
            last_update_datetime = $(this).attr('data-last_update_datetime'),
            work_time_from_hi = $(this).attr('data-work_time_from_hi'),
            work_time_to_hi = $(this).attr('data-work_time_to_hi'),
            state = $(this).attr('data-state');

        if (state !== 'keep') {
            params.append(`help_requests[${idx}][help_request_id]`, help_request_id);
            params.append(`help_requests[${idx}][last_update_datetime]`, last_update_datetime);
            params.append(`help_requests[${idx}][work_time_from_hi]`, work_time_from_hi);
            params.append(`help_requests[${idx}][work_time_to_hi]`, work_time_to_hi);

            idx ++;
        }
    });
    const deleted_ids = $form_navigation.find('input[type="hidden"][name="deleted_ids"]').val();
    params.append('deleted_ids', deleted_ids);

    // シフト
    let idx1 = 0;
    $table_dayly.find('tbody').find('tr.tr-employee').each(function() {
        const employee_id = $(this).attr('data-employee_id'),
            work_plan_state = $(this).attr('data-work_plan_state');

        if (work_plan_state !== 'keep') {
            params.append(`employee_id[${idx1}]`, employee_id);
            params.append(`work_plan_state[${idx1}]`, work_plan_state);
            let idx2 = 0;
            $(this).find('.div-shift-bar').each(function() {
                const work_plan_id = $(this).attr('data-work_plan_id'),
                    update_datetime = $(this).attr('data-update_datetime'),
                    organization_id = $(this).attr('data-organization_id'),
                    is_help = $(this).attr('data-is_help'),
                    is_help_organization = $(this).attr('data-is_help_organization'),
                    work_type = $(this).attr('data-work_type'),
                    work_time_from = $(this).attr('data-work_time_from'),
                    work_time_to = $(this).attr('data-work_time_to'),
                    work_plan_detail_id = $(this).attr('data-work_plan_detail_id'),
                    state = $(this).attr('data-state');

                params.append(`work_plan_id[${idx1}][${idx2}]`, work_plan_id);
                params.append(`update_datetime[${idx1}][${idx2}]`, update_datetime);
                params.append(`organization_id[${idx1}][${idx2}]`, organization_id);
                params.append(`is_help[${idx1}][${idx2}]`, is_help);
                params.append(`is_help_organization[${idx1}][${idx2}]`, is_help_organization);
                params.append(`work_type[${idx1}][${idx2}]`, work_type);
                params.append(`work_time_from[${idx1}][${idx2}]`, work_time_from);
                params.append(`work_time_to[${idx1}][${idx2}]`, work_time_to);
                params.append(`work_plan_detail_id[${idx1}][${idx2}]`, work_plan_detail_id);
                params.append(`state[${idx1}][${idx2}]`, state);
                idx2 ++;
            });
            idx1 ++;
        }
    });

    axios.post(VALIDATE_STORE_WORK_PLAN_ALL_API_ENDPOINT, params)
    .then(res => {
        const data = res.data;
        if (data.length > 0) {
            let html = `<ul>\n`;
            $.each(data, function(k, v) {
                html += `<li>${v.message}</li>\n`;
            })
            html += `</ul>\n`;
            $flash_message.find('.exec-result-message').html(html).show();
            $(this).html(btn_html);
            $btn.prop('disabled', false);
        } else {
            $flash_message.find('.exec-result-message').html('').hide();
            let ret = false;
            if (is_alert) {
                ret = true;
                $modal_alert_at_save.modal('hide');
                $modal_alert_at_save.find('.modal-body').find('.alert-messages').empty();
                $modal_alert_at_save.find('#btn-save-alert').attr('data-standalone', '');
                $modal_alert_at_save.find('#btn-save-alert').attr('data-work_plan_type', '');
            } else {
                $modal_alert_at_save.find('.modal-body').find('.alert-messages').empty();
                const check_alerts = checkAlert();
                var show_alert = false;
                check_alerts.forEach(employee => {
                    if (employee.has_alert) {
                        show_alert = true;
                        let dl_html = ``;
                        alert_messages.forEach(alert_message => {
                            if (employee[alert_message.key]) {
                                dl_html += `<dd class="mb-0">${alert_message.val}</dd>\n`;
                            }
                        });
                        dl_html = `<dl class="mb-0">\n<dt>${employee.employee_name}さん</dt>\n${dl_html}</dl>\n`;
                        $modal_alert_at_save.find('.modal-body').find('.alert-messages').append(dl_html);
                    }
                });
                $modal_alert_at_save.find('#btn-save-alert').attr('data-standalone', '');
                $modal_alert_at_save.find('#btn-save-alert').attr('data-work_plan_type', '');
                // 画面移動
                if (move_function != 0) {
                    // 労務アラート有り => モーダルで表示
                    if (show_alert) {
                        $modal_alert_at_save.find('#btn-save-alert').attr('data-standalone', standalone);
                        $modal_alert_at_save.modal('show');
                    // 労務アラート無し => 何もしない
                    } else {
                        ret = true;
                    }
                } else {
                    // 一時保存
                    if (standalone) {
                        // 労務アラート有り => モーダルで表示
                        if (show_alert) {
                            $modal_alert_at_save.find('#btn-save-alert').attr('data-standalone', standalone);
                            $modal_alert_at_save.find('#btn-save-alert').attr('data-work_plan_type', work_plan_type);
                            $modal_alert_at_save.modal('show');
                        // 労務アラート無し => ブラウザダイアログで表示
                        } else {
                            ret = confirm('保存してよろしいですか？');
                        }
                    // 確定
                    } else {
                        // 労務アラート有り => モーダルで表示
                        if (show_alert) {
                            $modal_alert_at_save.find('#btn-save-alert').attr('data-standalone', standalone);
                            $modal_alert_at_save.find('#btn-save-alert').attr('data-work_plan_type', work_plan_type);
                            $modal_alert_at_save.modal('show');
                        // 労務アラート無し => 何もしない
                        } else {
                            ret = true;
                        }
                    }
                }
            }
            if (ret) {
                axios.post(SET_TEMPORARILY_SHIFT_API_ENDPOINT, params)
                .then(res => {
                    const data = res.data;
                    let cnt_matching = 0;
                    data.forEach(v => {
                        // ヘルプの場合
                        if (v.help_request_id) {
                            // マッチングした場合
                            if (v.is_match) {
                                cnt_matching ++;
                                const help_data = v.help_data,
                                    create_count = Number($form_navigation.find('input[type="hidden"][name="create_count"]').val()),
                                    new_id = `new-shift-${create_count}`,
                                    $div_icon = '' +
                                        `<div class="d-flex flex-wrap">\n` +
                                            `<i class="fas fa-user-plus text-success"></i>\n` +
                                        `</div>\n`,
                                    $div_detail = '' +
                                        `<div class="div-shift-bar d-flex align-items-center resizable draggable work-type-5-bg" id="${new_id}"` +
                                        ` data-work_plan_id="${help_data.work_plan_id}"` +
                                        ` data-update_datetime="${help_data.update_datetime}"` +
                                        ` data-organization_id="${help_data.organization_id}"` +
                                        ` data-organization_name="${help_data.organization_name}"` +
                                        ` data-is_offday="${help_data.is_offday}"` +
                                        ` data-is_free="${help_data.is_free}"` +
                                        ` data-is_help="${help_data.is_help}"` +
                                        ` data-is_help_organization="${help_data.is_help_organization}"` +
                                        ` data-help_come="${help_data.help_come}"` +
                                        ` data-help_go="${help_data.help_go}"` +
                                        ` data-work_type="${help_data.work_type}"` +
                                        ` data-default_work_type="${help_data.default_work_type}"` +
                                        ` data-work_time_from="${help_data.work_time_from}"` +
                                        ` data-work_time_to="${help_data.work_time_to}"` +
                                        ` data-work_plan_detail_id="${help_data.work_plan_detail_id}"` +
                                        ` data-fixed="${help_data.fixed}"` +
                                        ` data-state="keep">\n` +
                                            `<div class="role text-nowrap"></div>\n` +
                                        `</div>\n`;

                                // 自店従業員（且つ表示中）の場合、既存の行を変更する
                                if ($(`tr[data-employee_id="${help_data.employee_id}"]`).length > 0) {
                                    const $tr = $(`tr.tr-employee[data-employee_id="${help_data.employee_id}"]`),
                                        $div = $tr.find('td.td-shift-time:first').find('div.droppable-area:first');

                                    $tr.attr('data-update_datetime', help_data.update_datetime)
                                        .attr('data-is_offday', help_data.is_offday)
                                        .attr('data-is_free', help_data.is_free)
                                        .attr('data-is_help', help_data.is_help)
                                        .attr('data-is_help_organization', help_data.is_help_organization)
                                        .attr('data-is_confirmed', help_data.is_confirmed)
                                        .attr('data-is_unsettled', help_data.is_unsettled)
                                        .attr('data-is_update_office', help_data.is_update_office)
                                        .attr('data-help_come', help_data.help_come)
                                        .attr('data-help_go', help_data.help_go)
                                        .attr('data-work_plan_detail_count', help_data.work_plan_detail_count)
                                        .attr('data-week_work_days', help_data.week_work_days)
                                        .attr('data-week_work_time', help_data.week_work_time)
                                        .attr('data-week_over_time', help_data.week_over_time)
                                        .attr('data-month_work_time', help_data.month_work_time)
                                        .attr('data-month_over_time', help_data.month_over_time)
                                        .attr('data-last_work_day_of_month', help_data.last_work_day_of_month)
                                        .attr('data-this_day_work_time', help_data.this_day_work_time)
                                        .attr('data-this_day_over_time', help_data.this_day_over_time)
                                        .attr('data-this_count_over_45', help_data.this_count_over_45)
                                        .attr('data-prev_count_over_45', help_data.prev_count_over_45)
                                        .attr('data-work_plan_state', 'keep')
                                        .attr('data-is_displayed_message', '');
                                    $tr.find('div.div-icons').append($($div_icon).prop('outerHTML'));
                                    $div.empty().append($($div_detail).prop('outerHTML'));

                                    // ヘルプ行を削除
                                    $(`div[data-help_request_id="${v.help_request_id}"]`).closest('tr.tr-help-request').remove();

                                // 自店従業員（且つ非表示）又は他店従業員の場合、ヘルプの行を変更する
                                } else {
                                    const $tr = $(`div[data-help_request_id="${v.help_request_id}"]`).closest('tr.tr-help-request'),
                                        $div = $tr.find('div.div-help-bar').closest('div.droppable-area');

                                    $tr.removeClass('tr-help-request').addClass('tr-employee')
                                        .attr('data-employee_id', help_data.employee_id)
                                        .attr('data-is_pjcrew', help_data.is_pjcrew)
                                        .attr('data-is_other', help_data.is_other)
                                        .attr('data-is_under_18', help_data.is_under_18)
                                        .attr('data-is_international_student', help_data.is_international_student)
                                        .attr('data-is_work_type_manager', help_data.is_work_type_manager)
                                        .attr('data-is_work_type_general', help_data.is_work_type_general)
                                        .attr('data-is_work_type_crew', help_data.is_work_type_crew)
                                        .attr('data-default_work_type', help_data.default_work_type)
                                        .attr('data-work_plan_id', '')
                                        .attr('data-update_datetime', help_data.update_datetime)
                                        .attr('data-is_offday', help_data.is_offday)
                                        .attr('data-is_free', help_data.is_free)
                                        .attr('data-is_help', help_data.is_help)
                                        .attr('data-is_help_organization', help_data.is_help_organization)
                                        .attr('data-is_confirmed', help_data.is_confirmed)
                                        .attr('data-is_unsettled', help_data.is_unsettled)
                                        .attr('data-is_update_office', help_data.is_update_office)
                                        .attr('data-is_offday_employee', help_data.is_offday_employee)
                                        .attr('data-is_free_employee', help_data.is_free_employee)
                                        .attr('data-is_requested', help_data.is_requested)
                                        .attr('data-is_accepted', help_data.is_accepted)
                                        .attr('data-is_closed_employee', help_data.is_closed_employee)
                                        .attr('data-help_come', help_data.help_come)
                                        .attr('data-help_go', help_data.help_go)
                                        .attr('data-work_plan_detail_count', help_data.work_plan_detail_count)
                                        .attr('data-is_employee_work_plan', help_data.is_employee_work_plan)
                                        .attr('data-data-this_help_permission', help_data.this_help_permission)
                                        .attr('data-next_help_permission', help_data.next_help_permission)
                                        .attr('data-week_work_days', help_data.week_work_days)
                                        .attr('data-week_work_time', help_data.week_work_time)
                                        .attr('data-week_over_time', help_data.week_over_time)
                                        .attr('data-month_work_time', help_data.month_work_time)
                                        .attr('data-month_over_time', help_data.month_over_time)
                                        .attr('data-last_work_day_of_month', help_data.last_work_day_of_month)
                                        .attr('data-this_day_work_time', help_data.this_day_work_time)
                                        .attr('data-this_day_over_time', help_data.this_day_over_time)
                                        .attr('data-this_count_over_45', help_data.this_count_over_45)
                                        .attr('data-prev_count_over_45', help_data.prev_count_over_45)
                                        .attr('data-work_plan_state', 'keep')
                                        .attr('data-is_displayed_message', '');
                                    $tr.find('div.employee-name').text(help_data.employee_name);
                                    if (help_data.help_come === '1') {
                                        $tr.find('div.organization-name').text(`(${help_data.belongs_organization_name})`);
                                    }
                                    $tr.find('div.div-icons').empty().append($($div_icon).prop('outerHTML'));
                                    $tr.find('button.btn-menu-employee-exec').removeClass('invisible');
                                    $tr.find('td.td-help-time').removeClass('td-help-time').addClass('td-shift-time');
                                    $div.empty().append($($div_detail).prop('outerHTML'));
                                }
                                const obj = $(`#${new_id}`);
                                setShift(obj, false, false);
                                $form_navigation.find('input[type="hidden"][name="create_count"]').val(create_count + 1);

                            // マッチングしなかった場合
                            } else {
                                $(`div[data-help_request_id="${v.help_request_id}"]`).attr('data-last_update_datetime', v.update_datetime).attr('data-state', 'keep');
                            }
                        // シフトの場合
                        } else {
                            const $tr = $(`tr[data-employee_id=${v.employee_id}]`),
                                tr_work_plan_id = Number($tr.attr('data-work_plan_id'));

                            if (v.exec === 'add') {
                                // tr更新
                                $tr.attr('data-work_plan_id', v.work_plan_id)
                                    .attr('data-update_datetime', v.update_datetime)
                                    .attr('data-work_plan_detail_count', v.work_plan_detail_count)
                                    .attr('data-is_update_office', '1')
                                    .attr('data-work_plan_state', 'keep');
                                // 不要なdivを削除
                                $tr.find('[data-state="deleted"]').remove();
                                // divを更新
                                $tr.find('[data-work_plan_id=""]')
                                    .attr('data-work_plan_id', v.work_plan_id)
                                    .attr('data-update_datetime', v.update_datetime)
                                    .attr('data-state', 'keep');
                            } else if (v.exec === 'update') {
                                // tr更新
                                $tr.attr('data-update_datetime', v.update_datetime)
                                    .attr('data-is_accepted', v.is_accepted)
                                    .attr('data-work_plan_detail_count', v.work_plan_detail_count)
                                    .attr('data-is_update_office', '1')
                                    .attr('data-is_requested', '')
                                    .attr('data-work_plan_state', 'keep');
                                // 不要なdivを削除
                                $tr.find('[data-state="deleted"]').remove();
                                // divを更新
                                $tr.find(`[data-work_plan_id="${v.work_plan_id}"]`)
                                    .attr('data-update_datetime', v.update_datetime)
                                    .attr('data-state', 'keep');
                            } else if (v.exec === 'delete') {
                                if (tr_work_plan_id === v.work_plan_id) {
                                    $tr.attr('data-work_plan_id', '')
                                        .attr('data-update_datetime', '')
                                        .attr('data-work_plan_detail_count', v.work_plan_detail_count)
                                        .attr('data-is_update_office', '')
                                        .attr('data-work_plan_state', 'keep');
                                }
                                $tr.find('[data-state="deleted"]').remove();
                            }
                        }
                    });

                    $table_dayly.find('tbody').find('tr.tr-employee').attr('data-work_plan_state', 'keep');
                    $form_navigation.find('input[type="hidden"][name="shift_edit_flag"]').val(0);

                    // 一次保存の場合
                    if (standalone) {
                        // ボタンと状態
                        $('#btn-unlock-shifts').addClass('d-none');
                        $('#btn-lock-shifts').removeClass('d-none');
                        $('.organization-work-plan-type').attr('class', 'fas fa-exclamation-circle text-danger organization-work-plan-type');
                        data.forEach(v => {
                            if (v.help_request_id) {
                                const $tr = $(`tr[data-employee_id=${v.employee_id}]`);
                                $tr.attr('data-is_unsettled', 1).attr('data-is_confirmed', '');
                                $tr.find('.confirmed').text('未').removeClass('confirmed').addClass('unsettled');
                            }
                        });

                        // メッセージ
                        let message = `<div class="flash_message alert alert-success auto-show-hide">シフトを保存しました。`;
                        if (cnt_matching > 0) {
                            message += `<br>${cnt_matching}件のヘルプ募集がマッチングされました。`;
                        }
                        message += `</div>`;

                        setTimeout(function() {
                            $flash_message.find('.auto-show-hide').remove();
                            $flash_message.append(message);
                            $flash_message.find('.auto-show-hide').slideDown();
                        }, auto_show_time);
                        setTimeout(function() {
                            $flash_message.find('.auto-show-hide').slideUp();
                            movePagefromModal();
                        }, auto_hide_time);
                    // 確定（解除）の場合
                    } else {
                        setOrganizationWorkPlanType(obj, work_plan_type, cnt_matching);
                    }

                    // 後処理（ヘルプ）
                    $form_navigation.find('input[type="hidden"][name="deleted_ids"]').val('');

                    // 編集中フラグ
                    change_data = false;
                    $('#header-menu-logout').attr({
                        href:"http://force.jp/logout",
                        onclick:"event.preventDefault(); document.getElementById('logout-form').submit();"
                    });

                    // セッションストレージにタイマー終了の時間情報をセット
                    sessionStorage.setItem('VIEW_MODE_TIME', getAddNow(TIME_TO_VIEW_MODE / 60 / 1000));
                })
                .catch(err => {
                    console.log(err);
                    alert(err);
                })
                .finally(() => {
                    $(this).html(btn_html);
                    $btn.prop('disabled', false);
                })
            } else {
                $(this).html(btn_html);
                $btn.prop('disabled', false);
            }
        }
    })
    .catch(err => {
        console.log(err);
        alert(err);
        $(this).html(btn_html);
        $btn.prop('disabled', false);
    })
    .finally(() => {
    })
};

/**
 * 日次 シフト確定/確定解除
 *
 * @param {object} obj              対象オブジェクト
 * @param {number} work_plan_type   勤務予定時間ステータス (1:確定、0：未確定)
 * @param {number} cnt_matching     マッチングされたヘルプの数
 * @returns {void}
 * @author hayakawa 2025.04.23
 */
export const setOrganizationWorkPlanType = (obj, work_plan_type, cnt_matching) => {
    const params = new URLSearchParams(),
        $btn = $('button'),
        btn_html = $(obj).html(),
        is_confirmed = (work_plan_type === work_plan_type_confirmed) ? true : false;

    $btn.prop('disabled', true);
    $(obj).html($spinner);
    params.append('organization_id', organization_id);
    params.append('ymd', view_date);
    params.append('work_plan_type', work_plan_type);
    axios.get(`${SET_ORGANIZATION_WORK_PLAN_TYPE_API_ENDPOINT}?${params.toString()}`)
    .then(res => {
        const data = res.data;
        let message_body = (is_confirmed) ? 'シフトを確定しました。' : 'シフトの確定を解除しました。';
        if (cnt_matching > 0) {
            message_body += `<br>${cnt_matching}件のヘルプ募集がマッチングされました。`;
        }
        const message = `<div class="flash_message alert alert-success auto-show-hide">${message_body}</div>`;

        if (is_confirmed) {
            $('#btn-unlock-shifts').removeClass('d-none');
            $('#btn-lock-shifts').attr('class', 'btn btn-success btn-sm d-none');
            $('.organization-work-plan-type').attr('class', 'fas fa-check-circle text-success organization-work-plan-type');
            data.forEach(v => {
                const $tr = $(`tr[data-employee_id=${v.employee_id}]`);
                $tr.attr('data-update_datetime', v.update_datetime).attr('data-is_unsettled', '').attr('data-is_confirmed', 1);
                $tr.find('[data-state=keep]').attr('data-update_datetime', v.update_datetime);
                $tr.find('.unsettled').text('確').removeClass('unsettled').addClass('confirmed');
            });
        } else {
            $('#btn-unlock-shifts').addClass('d-none');
            $('#btn-lock-shifts').removeClass('d-none');
            $('.organization-work-plan-type').attr('class', 'fas fa-minus-circle text-secondary organization-work-plan-type');
        }

        setTimeout(function() {
            $flash_message.find('.auto-show-hide').remove();
            $flash_message.append(message);
            $flash_message.find('.auto-show-hide').slideDown();
        }, auto_show_time);
        setTimeout(function() {
            $flash_message.find('.auto-show-hide').slideUp();
        }, auto_hide_time);
    })
    .catch(err => {
        console.log(err);
        alert(err);
    })
    .finally(() => {
        $(obj).html(btn_html);
        $btn.prop('disabled', false);
    })
};

/**
 * 日次 ヘルプ可能期間
 *
 * @returns {void}
 * @author hayakawa 2023.10.18
 */
export const setHelpPermissionTerm = () => {
    const employee_id = $form_help_permission.find('[name=employee_id]').val(),
        params = new URLSearchParams();
    let html = '' +
        `<div>\n` +
            `<span class="help-term-from"></span>\n` +
            `<span class="help-term-to"></span>\n` +
        `</div>\n`;

    // ヘルプ可能期間の表示を初期化
    $modal_help_permission.find('.help-term').html(html);

    html = '';
    params.append('employee_id', employee_id);
    params.append('view_date', '');
    axios.get(`${GET_HELP_PERMITTION}?${params.toString()}`)
    .then(res => {
        const help_permission_dates = res.data.help_permission_dates,
            default_from_date = res.data.default_help_permission_date.from_date,
            default_to_date = res.data.default_help_permission_date.to_date,
            is_pj_crew = res.data.is_pj_crew;

        // PJクルーフラグの設定
        $form_help_permission.find('[name=is_pj_crew]').val(is_pj_crew);
        // デフォルトのヘルプ期間の設定
        if (default_from_date !== null) {
            $form_help_permission.find('[name=default_from]').val(default_from_date);
        }
        if (default_to_date !== null) {
            $form_help_permission.find('[name=default_to]').val(default_to_date);
        }
        // ヘルプ可能期間の表示設定
        if (help_permission_dates.length == 1) {
            html += '' +
            `<div>\n` +
                `<span class="help-term-from">` + help_permission_dates[0]['from_date'] + `</span>\n` +
                `<span class="mx-1">~</span>\n` +
                `<span class="help-term-to">` + help_permission_dates[0]['to_date'] + `</span>\n` +
            `</div>\n`;
        } else if (help_permission_dates.length == 2) {
            html += '' +
            `<div>\n` +
                `<span class="help-term-from">` + help_permission_dates[0]['from_date'] + `</span>\n` +
                `<span class="mx-1">~</span>\n` +
                `<span class="help-term-to">` + help_permission_dates[0]['to_date'] + `</span>\n` +
            `</div>\n` +
            `<div>\n` +
                `<span class="help-term-from">` + help_permission_dates[1]['from_date'] + `</span>\n` +
                `<span class="mx-1">~</span>\n` +
                `<span class="help-term-to">` + help_permission_dates[1]['to_date'] + `</span>\n` +
            `</div>\n`;
        }
    })
    .catch(err => {
        console.log(err);
        alert(err);
    })
    .finally(() => {
        if (html === '') {
            html += '' +
            `<div>\n` +
            `<span>ヘルプを利用できません。</span>` +
            `<span class="help-term-from"></span>\n` +
                `<span class="help-term-to"></span>\n` +
            `</div>\n`;
        }
        $modal_help_permission.find('.help-term').html(html);
    });
}

/**
 * 日次 ヘルプ可能期間
 *
 * TODO: 定数化する
 * @returns {void}
 * @author hayakawa 2023.10.18
 */
export const setHelpPermissionTermDisplay = () => {
    const default_from = $form_help_permission.find('[name=default_from]').val(),
        default_to = $form_help_permission.find('[name=default_to]').val(),
        this_last = $form_help_permission.find('[name=this_last]').val(),
        next_first = $form_help_permission.find('[name=next_first]').val(),
        next_last = $form_help_permission.find('[name=next_last]').val(),
        after_next_first = $form_help_permission.find('[name=after_next_first]').val(),
        after_next_last = $form_help_permission.find('[name=after_next_last]').val(),
        this_help_permission = Number($form_help_permission.find('[name=this_help_permission]').val()),
        next_help_permission = Number($form_help_permission.find('[name=next_help_permission]').val()),
        is_pj_crew = Number($form_help_permission.find('[name=is_pj_crew]').val()),
        default_to_date = new Date(default_to),
        next_first_date = new Date(next_first);

    // ヘルプ可能期間の表示を初期化
    let html = '' +
        `<div>\n` +
            `<span class="help-term-from"></span>\n` +
            `<span class="help-term-to"></span>\n` +
        `</div>\n`;

    if (is_pj_crew == 1) {
        // PJクルーの場合
        if (this_help_permission == 2) {
            if (next_help_permission == 2) {
                // 今月と来月がNGの場合は再来月の1日から
                html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + after_next_first + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + default_to + `</span>\n` +
                    `</div>\n`;
            } else {
                // 今月のみNGの場合は来月の1日から
                html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + next_first + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + default_to + `</span>\n` +
                    `</div>\n`;
            }
        } else {
            if (next_help_permission == 2) {
                // 来月のみNGの場合は今月と再来月
                html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + default_from + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + this_last + `</span>\n` +
                    `</div>\n`+
                    `<div>\n` +
                        `<span class="help-term-from">` + after_next_first + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + after_next_last + `</span>\n` +
                    `</div>\n`;
            } else {
                // 今月と来月がNGじゃない場合はデフォルトのまま
                html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + default_from + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + default_to + `</span>\n` +
                    `</div>\n`;
            }
        }
    } else {
        // 一般クルーの場合
        if (this_help_permission == 1) {
            // 今月OK
            if (next_help_permission == 1) {
                // 今月OK、来月OKの場合、来月末まで
                html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + default_from + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + next_last + `</span>\n` +
                    `</div>\n`;
            } else if (next_help_permission == 2) {
                // 今月OK、来月NGの場合、今月の末日まで
                html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + default_from + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + this_last + `</span>\n` +
                    `</div>\n`;
            } else {
                // 今月OK、来月未設定、
                if (default_to_date <= next_first_date) {
                    // デフォルトの終了日が月内の場合は、今月の末日まで
                    html = '' +
                        `<div>\n` +
                            `<span class="help-term-from">` + default_from + `</span>\n` +
                            `<span class="mx-1">~</span>\n` +
                            `<span class="help-term-to">` + this_last + `</span>\n` +
                        `</div>\n`;
                } else {
                    // デフォルトの終了日が来月の場合はデフォルトのまま
                    html = '' +
                        `<div>\n` +
                            `<span class="help-term-from">` + default_from + `</span>\n` +
                            `<span class="mx-1">~</span>\n` +
                            `<span class="help-term-to">` + default_to + `</span>\n` +
                        `</div>\n`;
                }
            }
        } else if (this_help_permission == 2) {
            // 今月NG
            if (next_help_permission == 1) {
                // 今月NG、来月OKの場合は来月中
                html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + next_first + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + next_last + `</span>\n` +
                    `</div>\n`;
            } else if (next_help_permission == 2) {
                // 今月NG、来月NGの場合はヘルプ可能期間なし
                html += '' +
                    `<div>\n` +
                        `<span>ヘルプを利用できません。</span>` +
                        `<span class="help-term-from"></span>\n` +
                        `<span class="help-term-to"></span>\n` +
                    `</div>\n`;
            } else {
                // 今月NG、来月未設定の場合
                if (default_to_date <= next_first_date) {
                    // デフォルトの終了日が今月内の場合はヘルプ可能期間なし
                    html += '' +
                    `<div>\n` +
                        `<span>ヘルプを利用できません。</span>` +
                        `<span class="help-term-from"></span>\n` +
                        `<span class="help-term-to"></span>\n` +
                    `</div>\n`;
                } else {
                    // デフォルトの終了日が来月の場合は、来月の1日から
                    html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + next_first + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + default_to + `</span>\n` +
                    `</div>\n`;
                }
            }
        } else {
            // 今月未設定
            if (next_help_permission == 1) {
                // 今月未設定、来月OKの場合
                if (default_to_date <= next_first_date) {
                    // デフォルトの終了日が今月内の場合、デフォルトと来月
                    html = '' +
                        `<div>\n` +
                            `<span class="help-term-from">` + default_from + `</span>\n` +
                            `<span class="mx-1">~</span>\n` +
                            `<span class="help-term-to">` + default_to + `</span>\n` +
                        `</div>\n`+
                        `<div>\n` +
                            `<span class="help-term-from">` + next_first + `</span>\n` +
                            `<span class="mx-1">~</span>\n` +
                            `<span class="help-term-to">` + next_last + `</span>\n` +
                        `</div>\n`;
                } else {
                    // デフォルトの終了日が来月の場合は、来月の末日まで
                    html = '' +
                        `<div>\n` +
                            `<span class="help-term-from">` + default_from + `</span>\n` +
                            `<span class="mx-1">~</span>\n` +
                            `<span class="help-term-to">` + next_last + `</span>\n` +
                        `</div>\n`;
                }
            } else if (next_help_permission == 2) {
                // 今月未設定、来月NG
                if (default_to_date <= next_first_date) {
                    // デフォルトの終了日が今月内の場合、デフォルト
                    html = '' +
                        `<div>\n` +
                            `<span class="help-term-from">` + default_from + `</span>\n` +
                            `<span class="mx-1">~</span>\n` +
                            `<span class="help-term-to">` + default_to + `</span>\n` +
                        `</div>\n`;
                } else {
                    // デフォルトの終了日が来月の場合は、今月の末日まで
                    html = '' +
                        `<div>\n` +
                            `<span class="help-term-from">` + default_from + `</span>\n` +
                            `<span class="mx-1">~</span>\n` +
                            `<span class="help-term-to">` + this_last + `</span>\n` +
                        `</div>\n`;
                }
            } else {
                // 今月、来月が未設定の場合はデフォルト
                html = '' +
                    `<div>\n` +
                        `<span class="help-term-from">` + default_from + `</span>\n` +
                        `<span class="mx-1">~</span>\n` +
                        `<span class="help-term-to">` + default_to + `</span>\n` +
                    `</div>\n`;
            }
        }
    }
    $modal_help_permission.find('.help-term').html(html);
}

/**
 * モーダルコンテンツ ヘルプ検索
 *
 * @param {string} mode
 * @param {object} obj
 * @returns {void}
 * @author hayakawa 2023.10.18
 */
export const getHelpSearch = (mode, obj) => {
    const employee_id = $form_help_search.find('[name=employee_id]').val(),
        is_pjcrew = $form_help_search.find('[name=is_pjcrew]').val(),
        work_plan_id = $form_help_search.find('[name=work_plan_id]').val(),
        work_date = $form_help_search.find('[name=work_date]').val(),
        help_to_organization_ids = $form_help_search.find('[name=help_to_organization_ids]').val(),
        params = new URLSearchParams(),
        $btn = $('button'),
        btn_html = obj.html();

    $btn.prop('disabled', true);
    obj.html($spinner);
    params.append('organization_id', organization_id);
    params.append('employee_id', employee_id);
    params.append('work_date', work_date);
    params.append('help_to_organization_ids', help_to_organization_ids);
    axios.get(`${GET_HELP_SEARCH_API_ENDPOINT}?${params.toString()}`)
    .then(res => {
        const employee_setting_help = res.data.employee_setting_help,
            help_to = res.data.help_to,
            help_request = res.data.help_request,
            employee_setting_helps = res.data.employee_setting_helps,
            help_to_organization_names = res.data.help_to_organization_names,
            new_help_to_organization_ids = res.data.help_to_organization_ids;
        let html = '';

        help_request.forEach(v => {
            const help_request_setting = v.help_request_setting,
                help_request_settings = help_request_setting.split(',');
            let prev_help_setting_kind = 0,
                tr = '';

            tr += '' +
            `<tr>\n` +
                `<td class="align-middle text-center">\n` +
                    `<span class="help-organization-name">${v.organization_name}</span>\n` +
                `</td>\n` +
                `<td class="align-middle text-center">\n` +
                    `<section class="help-work-time">\n` +
                        `<span class="help-work-time-from">${v.work_time_from}</span>\n` +
                        `<span>~</span>\n` +
                        `<span class="help-work-time-to">${v.work_time_to}</span>\n` +
                    `</section>\n` +
                `</td>\n` +
                `<td class="align-middle text-center">\n` +
                    `<section class="help-work-time">\n` +
                        `<span class="help-core-work-from">${v.core_work_from}</span>\n` +
                        `<span>~</span>\n` +
                        `<span class="help-core-work-to">${v.core_work_to}</span>\n` +
                    `</section>\n` +
                `</td>\n` +
                `<td class="align-middle">\n` +
                    `<div class="fa-sm d-flex flex-column">\n`;
            help_request_settings.forEach(v2 => {
                const help_settings = v2.split('-'),
                    help_setting_kind = Number(help_settings[0]),
                    help_setting_name = help_settings[2];
                if (prev_help_setting_kind !== help_setting_kind) {
                    switch (help_setting_kind) {
                        case 1: tr += `<section class="help-work-type">\n`; break;
                        case 2: tr += `</section>\n<section class="help-make-skill">\n`; break;
                        case 3: tr += `</section>\n<section class="help-licence">\n`; break;
                        case 4: tr += `</section>\n<section class="help-bring">\n`; break;
                    }
                }
                tr += '' +
                            `<span class="mr-1">${help_setting_name}</span>\n`;
                prev_help_setting_kind = help_setting_kind;
            });
            tr += '' +
                        `</section>\n` +
                    `</div>\n` +
                `</td>\n` +
                `<td class="align-middle text-center">\n` +
                    `<div class="d-flex flex-column justify-content-between">\n` +
                        `<button class="btn btn-sm btn-outline-secondary btn-accept-help" data-help_request_id="${v.help_request_id}">\n` +
                            `<i class="fas fa-check-square"></i>\n` +
                            `受付\n` +
                        `</button>\n` +
                    `</div>\n` +
                `</td>\n` +
            `</tr>\n`;
            html += $(tr).prop('outerHTML');
        });
        $form_help_search.find('[name=help_to_organization_ids ]').val(new_help_to_organization_ids);
        $modal_help_search.find('.employee-setting-help').text(employee_setting_helps);
        $modal_help_search.find('.help-to').text(help_to_organization_names);
        $modal_help_search.find('.table-matching-search').find('tbody').html(html);
        if (mode === 'default') {
            $modal_help_search.modal('show');
        } else if (mode === 'custom') {
            $modal_search_organization.modal('hide');
        }
    })
    .catch(err => {
        console.log(err);
        alert(err);
    })
    .finally(() => {
        obj.html(btn_html);
        $btn.prop('disabled', false);
    })
}

/**
 * 日次 保存時のアラートチェック
 *
 * 他店のクルーはチェックしない
 * 画面上での変化がないクルーはチェックしない
 * @returns {array}
 * @author hayakawa 2023.10.18
 */
export const checkAlert = () => {
    const this_day = Number($form_navigation.find('[name=this_day]').val()),                            // 表示日
        last_day_of_month = Number($form_navigation.find('[name=last_day_of_month]').val()),            // 月末日(月の日数)
        free_default_work_time = Number($form_navigation.find('[name=free_default_work_time]').val());  // フリーの労働時間
    let employee_datas = [];                                                                            // 戻り値（従業員情報の配列）

    // 従業員繰り返し
    $(`table.table-dayly`).find('tbody').find('tr').each(function() {
        const employee_id = $(this).attr('data-employee_id'),                                           // 従業員ID
            employee_name = $(this).find('.employee-name').text(),                                      // 従業員名
            is_other = $(this).attr('data-is_other'),                                                   // 他店クルー
            is_under_18 = $(this).attr('data-is_under_18'),                                             // 18歳未満
            is_international_student = $(this).attr('data-is_international_student'),                   // 留学生
            is_work_type_manager = $(this).attr('data-is_work_type_manager'),                           // 店長、副店長
            is_work_type_general = $(this).attr('data-is_work_type_general'),                           // 社員
            is_work_type_crew = $(this).attr('data-is_work_type_crew'),                                 // クルー
            work_plan_state = $(this).attr('data-work_plan_state'),                                     // 状態
            week_work_days = Number($(this).attr('data-week_work_days')),                               // 週の労働日数
            week_work_time = Number($(this).attr('data-week_work_time')),                               // 週の労働時間
            week_over_time = Number($(this).attr('data-week_over_time')),                               // 週の残業時間
            month_work_time = Number($(this).attr('data-month_work_time')),                             // 月の労働時間
            month_over_time = Number($(this).attr('data-month_over_time')),                             // 月の残業時間
            last_work_day_of_month = Number($(this).attr('data-last_work_day_of_month')),               // 月の最後の出勤予定日
            this_day_work_time = Number($(this).attr('data-this_day_work_time')),                       // 表示日の労働時間
            this_day_over_time = Number($(this).attr('data-this_day_over_time')),                       // 表示日の残業時間
            count_day = (this_day < last_work_day_of_month) ? last_work_day_of_month : this_day,        // カウント日
            this_count_over_45 = Number($(this).attr('data-this_count_over_45')),                       // 今月の45時間越え回数
            prev_count_over_45 = Number($(this).attr('data-prev_count_over_45')),                       // 先月の45時間越え回数
            is_this_month_over_45 = (this_count_over_45 > prev_count_over_45) ? true : false;           // 今月に45時間超えたか否か
        let new_this_day_work_time_to_h = 0,                                                            // 表示日の終了時間(新)
            new_this_day_work_time_to_half = false,                                                     // 表示日の終了時間(新)
            new_week_work_days = 0,                                                                     // 週の労働日数(新)
            new_week_work_time = 0,                                                                     // 週の労働時間(新)
            new_week_over_time = 0,                                                                     // 週の残業時間(新)
            new_month_work_time = 0,                                                                    // 月の労働時間(新)
            new_month_over_time = 0,                                                                    // 月の残業時間(新)
            new_this_day_work_time = 0,                                                                 // 表示日の労働時間(新)
            new_this_day_over_time = 0,                                                                 // 表示日の残業時間(新)
            predict_month_work_time = 0,                                                                // 月の予測労働時間
            predict_month_over_time = 0,                                                                // 月の予測残業時間
            new_count_over_45 = 0,                                                                      // 45時間越え回数
            employee_data = [];                                                                         // 従業員情報

        if (work_plan_state !== 'keep') {
            employee_data['employee_id'] = employee_id;
            employee_data['employee_name'] = employee_name;
            employee_data['is_other'] = (is_other) ? true : false;
            employee_data['has_alert'] = false;

            // シフト繰り返し
            $(this).find('.div-shift-bar').not(`[data-work_type=${work_type_offday}],[data-state=deleted]`).each(function() {
                const work_type = $(this).attr('data-work_type'),                                           // 職種
                    work_time_from = $(this).attr('data-work_time_from'),                                   // 開始時分
                    work_time_froms = work_time_from.split(':'),                                            // 時分を分割
                    work_time_from_h = Number(work_time_froms[0]),                                          // 開始時
                    work_time_from_m = Number(work_time_froms[1]),                                          // 開始分
                    work_time_from_half = (work_time_from_m === 30) ? true : false,                         // 開始が30分か否か
                    work_time_to = $(this).attr('data-work_time_to'),                                       // 終了時分
                    work_time_tos = work_time_to.split(':'),                                                // 時分を分割
                    work_time_to_h = Number(work_time_tos[0]),                                              // 終了時
                    work_time_to_m = Number(work_time_tos[1]),                                              // 終了分
                    work_time_to_half = (work_time_to_m === 30) ? true : false;                             // 終了が30分か否か
                let work_time = (work_time_to_h - work_time_from_h);                                        // 労働時間 (終了時 - 開始時)

                // 終了時間を更新
                if (new_this_day_work_time_to_h < work_time_to_h) {
                    new_this_day_work_time_to_h = work_time_to_h;
                    new_this_day_work_time_to_half = work_time_to_half;
                }

                // 開始30分の場合、減算
                if (work_time_from_half) {
                    work_time -= 0.5;
                }

                // 終了30分の場合、加算
                if (work_time_to_half) {
                    work_time += 0.5;
                }

                // フリーの場合、固定値を労働時間に加算
                if (work_type === work_type_free) {
                    new_this_day_work_time += free_default_work_time;
                // フリーと休憩ではない場合、普通に労働時間に加算
                } else if (work_type !== work_type_break) {
                    new_this_day_work_time += work_time;
                }
            });

            new_this_day_over_time = (new_this_day_work_time > 8) ? new_this_day_work_time - 8 : 0;         // 残業時間
            new_week_work_days = week_work_days - ((this_day_work_time > 0) ? 1 : 0) + ((new_this_day_work_time > 0) ? 1 : 0);  // 週の労働日数
            new_week_work_time = week_work_time - this_day_work_time + new_this_day_work_time;              // 週の労働時間
            new_week_over_time = week_over_time - this_day_over_time + new_this_day_over_time;              // 週の残業時間
            new_month_work_time = month_work_time - this_day_work_time + new_this_day_work_time;            // 月の労働時間
            new_month_over_time = month_over_time - this_day_over_time + new_this_day_over_time;            // 月の残業時間
            predict_month_work_time = new_month_work_time * last_day_of_month / count_day;                  // 月の予測労働時間
            predict_month_over_time = new_month_over_time * last_day_of_month / count_day;                  // 月の予測残業時間

            // 週7日勤務 (全員)
            employee_data['is_full_worked'] = false;
            if (new_week_work_days === 7) {
                employee_data['is_full_worked'] = employee_data['has_alert'] = true;
            }

            // 店長・副店長
            employee_data['is_over_time_w16_m80'] = false;
            if (is_work_type_manager) {
                // 残業週16時間以上又は月80時間以上
                if (new_week_over_time >= 16 || predict_month_over_time >= 80) {
                    employee_data['is_over_time_w16_m80'] = employee_data['has_alert'] = true;
                }
            }

            // 社員
            employee_data['is_over_time_m25'] = false;
            if (is_work_type_general) {
                // 残業月25時間以上
                if (predict_month_over_time >= 25) {
                    employee_data['is_over_time_m25'] = employee_data['has_alert'] = true;
                }
            }

            // クルー
            employee_data['is_over_time_m45_5'] = employee_data['is_over_time_m45_6'] = employee_data['is_over_time_m45_7'] = false;
            if (is_work_type_crew) {
                // 残業45時間以上
                if (is_this_month_over_45 || predict_month_over_time >= 45) {
                    new_count_over_45 = (is_this_month_over_45) ? this_count_over_45 : prev_count_over_45 + 1;
                    const key = `is_over_time_m45_${new_count_over_45}`;
                    employee_data[key] = employee_data['has_alert'] = true;
                }
            }

            // 18歳未満
            employee_data['is_to_time_21'] = employee_data['is_to_time_22'] = employee_data['is_over_time'] = false;
            if (is_under_18) {
                // 終了が21時台
                if ((new_this_day_work_time_to_h === 21 && new_this_day_work_time_to_half) || (new_this_day_work_time_to_h === 22 && !new_this_day_work_time_to_half)) {
                    employee_data['is_to_time_21'] = employee_data['has_alert'] = true;
                }

                // 終了が22時台
                if ((new_this_day_work_time_to_h === 22 && new_this_day_work_time_to_half) || new_this_day_work_time_to_h > 22) {
                    employee_data['is_to_time_22'] = employee_data['has_alert'] = true;
                }

                // 残業あり ※このケースは無いはず
                if (new_this_day_over_time > 0) {
                    employee_data['is_over_time'] = employee_data['has_alert'] = true;
                }
            }

            // 留学生
            employee_data['is_work_time_w28'] = employee_data['is_over_time'] = false;
            if (is_international_student) {
                // 週労働時間28時間
                if (new_week_work_time > 28) {
                    employee_data['is_work_time_w28'] = employee_data['has_alert'] = true;
                }

                // 残業あり ※このケースは無いはず
                if (new_this_day_over_time > 0) {
                    employee_data['is_over_time'] = employee_data['has_alert'] = true;
                }

                // 週7日勤務 ※このケースは無いはず
                if (new_week_work_days === 7) {
                    employee_data['is_full_worked'] = employee_data['has_alert'] = true;
                }
            }

            employee_datas.push(employee_data);
        }
    });

    return employee_datas;
}

/**
 * ヘルプ マッチング検索
 *
 * TODO: 定数化する
 * @param {string} mode モード
 * @param {object} obj オブジェクト
 * @param {number|null} help_request_id ヘルプ募集ID
 * @return {void}
 * @author hayakawa 2023.10.18
 */
export const searchMatchingForHelp = (mode, obj, help_request_id) => {
    if (mode === 'own' || mode === 'other') {
        var params = new URLSearchParams();
        params.append('help_request_id', help_request_id);
        params.append('organization_id', organization_id);
    } else if (mode === 'own-search') {
        var $form_data = new FormData($form_search_organization.get(0)),
            params = new URLSearchParams($form_data);
        params.append('help_request_id', help_request_id);
    }

    const $btn = $('button'),
        btn_html = obj.html();

    $btn.prop('disabled', true);
    obj.html($spinner);
    params.append('mode', mode);
    axios.get(`${GET_MATCHING_SEARCH_API_ENDPOINT}?${params.toString()}`)
    .then(res => {
        const help_request = res.data.help_request,
            help_request_setting = res.data.help_request_setting,
            organization_help_from = res.data.organization_help_from,
            employee_help_request = res.data.employee_help_request;
        let help_setting_kind = '',
            html = '';

        $modal_matching_search.find('.help-work-date').text(help_request.work_date_ymd);
        $modal_matching_search.find('.help-work-date-week').text(help_request.work_date_week);
        $modal_matching_search.find('.help-work-time-from').text(help_request.work_time_from_hi);
        $modal_matching_search.find('.help-work-time-to').text(help_request.work_time_to_hi);
        $modal_matching_search.find('.help-core-work-from').text(help_request.core_work_from_hi);
        $modal_matching_search.find('.help-core-work-to').text(help_request.core_work_to_hi);
        $modal_matching_search.find('.help-request-setting').find('section').empty();
        help_request_setting.forEach(v => {
            switch (v.setting_kind) {
                case 1: help_setting_kind = '.help-work-type'; break;
                case 2: help_setting_kind = '.help-make-skill'; break;
                case 3: help_setting_kind = '.help-licence'; break;
                case 4: help_setting_kind = '.help-bring'; break;
            }
            $modal_matching_search.find(help_setting_kind).append(`<span class="mr-1">${v.setting_name}</span>\n`);
        });

        if (mode === 'own' || mode === 'own-search') {
            let help_from_organization_names = '',
                help_from_organization_ids = '';
            organization_help_from.forEach(v => {
                help_from_organization_names += (help_from_organization_names === '') ? v.organization_name : ` ${v.organization_name}`;
                help_from_organization_ids += (help_from_organization_ids === '') ? v.organization_id : `,${v.organization_id}`;
            });
            if (mode === 'own') {
                $modal_matching_search.find('.help-from-organization-names').html(help_from_organization_names);
                $modal_matching_search.find('[name=help_from_organization_ids]').val(help_from_organization_ids);
            }
            $modal_matching_search.find('.request-organization').hide();
            $modal_matching_search.find('.help-from').show();
        } else if (mode === 'other') {
            $modal_matching_search.find('.request-organization').find('section').html(help_request.organization_name);
            $modal_matching_search.find('.help-from').hide();
            $modal_matching_search.find('.request-organization').show();
        }
        employee_help_request.forEach(v => {
            const job_request_setting = v.job_request_setting,
                job_request_settings = job_request_setting.split(',');
            let prev_job_setting_kind = 0,
                tr = '';
            tr += `<tr data-employee_help_request_id="${v.employee_help_request_id}" data-employee_id="${v.employee_id}">\n`;
            if (mode === 'other') {
                tr += `<td class="align-middle text-center">${v.employee_name}</td>\n`;
            }
            tr += '' +
                `<td class="align-middle text-center">\n` +
                    `<section class="job-work-time" data-job_work_type="${v.work_type}">\n`;
            if (v.work_type === 1) {
                tr += '' +
                        `<span class="job-work-time-from">${v.request_work_time_from}</span>\n` +
                        `<span>~</span>\n` +
                        `<span class="job-work-time-to">${v.request_work_time_to}</span>\n`;
            } else {
                tr += `<span>フリー</span>\n`;
            }
            tr += '' +
                    `</section>\n` +
                `</td>\n` +
                `<td class="align-middle">\n` +
                    `<div class="fa-sm d-flex flex-column">\n`;
            job_request_settings.forEach(v2 => {
                const job_settings = v2.split('-'),
                    job_setting_kind = Number(job_settings[0]),
                    job_setting_name = job_settings[2];
                if (prev_job_setting_kind !== job_setting_kind) {
                    switch (job_setting_kind) {
                        case 1: tr += `<section class="job-work-type">\n`; break;
                        case 2: tr += `</section>\n<section class="job-make-skill">\n`; break;
                        case 3: tr += `</section>\n<section class="job-licence">\n`; break;
                        case 4: tr += `</section>\n<section class="job-bring">\n`; break;
                    }
                }
                tr += '' +
                            `<span class="mr-1">${job_setting_name}</span>\n`;
                prev_job_setting_kind = job_setting_kind;
            });
            tr += '' +
                        `</section>\n` +
                    `</div>\n` +
                `</td>\n` +
                `<td class="align-middle text-center">\n` +
                    `<div class="d-flex justify-content-between">\n`;
            // 交渉中、区分:フリーは交渉不可
            if (v.status == 3 || v.work_type === 2) {
                tr += '' +
                        `<button class="btn btn-sm btn-outline-secondary btn-show-negotiation-add disabled" disabled>\n` +
                            `<i class="fas fa-arrow-right"></i>\n` +
                            `交渉\n` +
                        `</button>\n`;
            } else {
                tr += '' +
                        `<button class="btn btn-sm btn-outline-secondary btn-show-negotiation-add">\n` +
                            `<i class="fas fa-arrow-right"></i>\n` +
                            `交渉\n` +
                        `</button>\n`;
            }
            tr += '' +
                        `<button class="btn btn-sm btn-outline-secondary btn-show-help-history">\n` +
                            `<i class="fas fa-history"></i>\n` +
                            `履歴\n` +
                        `</button>\n` +
                    `</div>\n` +
                    `<div class="mt-1 text-right">\n` +
                        `<button class="btn btn-sm btn-outline-secondary btn-accept-help-request">\n` +
                            `<i class="fas fa-check-square"></i>\n` +
                            `受付\n` +
                        `</button>\n` +
                    `</div>\n` +
                `</td>\n` +
            `</tr>\n`;
            html += $(tr).prop('outerHTML');
        });
        if (mode === 'own' || mode === 'own-search') {
            $modal_matching_search.find('.table-matching-search.other').hide();
            $modal_matching_search.find('.table-matching-search.own').find('tbody').html(html);
            $modal_matching_search.find('.table-matching-search.own').show();
        } else if (mode === 'other') {
            $modal_matching_search.find('.table-matching-search.own').hide();
            $modal_matching_search.find('.table-matching-search.other').find('tbody').html(html);
            $modal_matching_search.find('.table-matching-search.other').show();
        }
        if (mode === 'own' || mode === 'other') {
            $modal_matching_search.attr('data-help_request_id', help_request_id).modal('show');
        } else if (mode === 'own-search') {
            $modal_search_organization.modal('hide');
        }
    })
    .catch(err => {
        console.log(err);
        alert(err);
    })
    .finally(() => {
        obj.html(btn_html);
        $btn.prop('disabled', false);
    })
};

/**
 * ジョブ マッチング検索
 *
 * TODO: 定数化する
 * @param {string} mode モード
 * @param {object} obj オブジェクト
 * @param {number|null} employee_help_request_id ジョブ応募ID
 * @return {void}
 * @author hayakawa 2023.11.22
 */
export const searchMatchingForJob = (mode, obj, employee_help_request_id) => {
    if (mode === 'list') {
        var params = new URLSearchParams();
        params.append('employee_help_request_id', employee_help_request_id);
    } else if (mode === 'search') {
        var $form_data = new FormData($form_search_organization.get(0)),
            params = new URLSearchParams($form_data);
        params.append('employee_help_request_id', employee_help_request_id);
    }
    const $btn = $('button'),
        btn_html = obj.html();
    $btn.prop('disabled', true);
    obj.html($spinner);
    params.append('mode', mode);
    axios.get(`${GET_MATCHING_SEARCH_API_ENDPOINT}?${params.toString()}`)
    .then(res => {
        const employee_help_request = res.data.employee_help_request,
            employee_help_request_setting = res.data.employee_help_request_setting,
            organization_help_to = res.data.organization_help_to,
            help_request = res.data.help_request;
        let job_setting_kind = '',
            html = '';
        $modal_matching_search.find('.job-work-date').text(employee_help_request.work_date_ymd);
        $modal_matching_search.find('.job-work-date-week').text(employee_help_request.work_date_week);
        $modal_matching_search.find('.job-work-time-from').text(employee_help_request.work_time_from_hi);
        $modal_matching_search.find('.job-work-time-to').text(employee_help_request.work_time_to_hi);
        $modal_matching_search.find('.job-request-setting').find('section').empty();
        employee_help_request_setting.forEach(v => {
            switch (v.setting_kind) {
                case 1: job_setting_kind = '.job-work-type'; break;
                case 2: job_setting_kind = '.job-make-skill'; break;
                case 3: job_setting_kind = '.job-licence'; break;
                case 4: job_setting_kind = '.job-bring'; break;
            }
            $modal_matching_search.find(job_setting_kind).append(`<span class="mr-1">${v.setting_name}</span>\n`);
        });

        if (mode === 'list') {
            let help_to_organization_names = '',
                help_to_organization_ids = '';
            organization_help_to.forEach(v => {
                help_to_organization_names += (help_to_organization_names === '') ? v.organization_name : ` ${v.organization_name}`;
                help_to_organization_ids += (help_to_organization_ids === '') ? v.organization_id : `,${v.organization_id}`;
            });
            $modal_matching_search.find('.help-to-organization-names').html(help_to_organization_names);
            $modal_matching_search.find('[name=help_to_organization_ids]').val(help_to_organization_ids);
        }

        help_request.forEach(v => {
            const help_request_setting = v.help_request_setting,
            help_request_settings = help_request_setting.split(',');
            let prev_help_setting_kind = 0,
                tr = '' +
            `<tr data-help_request_id="${v.help_request_id}" data-organization_id="${v.organization_id}">\n` +
                `<td class="align-middle text-center">\n` +
                    `<span class="help-organization-name">${v.organization_name}</span>\n` +
                `</td>\n` +
                `<td class="align-middle text-center">\n` +
                    `<section class="help-work-time">\n` +
                        `<span class="help-work-time-from">${v.work_time_from}</span>\n` +
                        `<span>~</span>\n` +
                        `<span class="help-work-time-to">${v.work_time_to}</span>\n` +
                    `</section>\n` +
                `</td>\n` +
                `<td class="align-middle text-center">\n` +
                    `<section class="help-work-time">\n` +
                        `<span class="help-core-work-from">${v.core_work_from}</span>\n` +
                        `<span>~</span>\n` +
                        `<span class="help-core-work-to">${v.core_work_to}</span>\n` +
                    `</section>\n` +
                `</td>\n` +
                `<td class="align-middle">\n` +
                    `<div class="fa-sm d-flex flex-column">\n`;
            help_request_settings.forEach(v2 => {
                const help_settings = v2.split('-'),
                    help_setting_kind = Number(help_settings[0]),
                    help_setting_name = help_settings[2];
                if (prev_help_setting_kind !== help_setting_kind) {
                    switch (help_setting_kind) {
                        case 1: tr += `<section class="help-work-type">\n`; break;
                        case 2: tr += `</section>\n<section class="help-make-skill">\n`; break;
                        case 3: tr += `</section>\n<section class="help-licence">\n`; break;
                        case 4: tr += `</section>\n<section class="help-bring">\n`; break;
                    }
                }
                tr += `<span class="mr-1">${help_setting_name}</span>\n`;
                prev_help_setting_kind = help_setting_kind;
            });
            tr += '' +
                        `</section>\n` +
                    `</div>\n` +
                `</td>\n` +
                `<td class="align-middle text-center">\n` +
                    `<div class="d-flex flex-column justify-content-between">\n`;
            // 交渉中、区分:フリーは交渉不可
            if (v.status == 3 || v.work_type === 2) {
                tr += '' +
                        `<button class="btn btn-sm btn-outline-secondary btn-show-negotiation-add mb-1 disabled" disabled>\n` +
                            `<i class="fas fa-arrow-right"></i>\n` +
                            `交渉\n` +
                        `</button>\n`;
            } else {
                tr += '' +
                        `<button class="btn btn-sm btn-outline-secondary btn-show-negotiation-add mb-1">\n` +
                            `<i class="fas fa-arrow-right"></i>\n` +
                            `交渉\n` +
                        `</button>\n`;
            }
            tr += '' +
                        `<button class="btn btn-sm btn-outline-secondary btn-accept-job-request">\n` +
                            `<i class="fas fa-check-square"></i>\n` +
                            `受付\n` +
                        `</button>\n` +
                    `</div>\n` +
                `</td>\n` +
            `</tr>\n`;
            html += $(tr).prop('outerHTML');
        });
        $modal_matching_search.find('.table-matching-search').find('tbody').html(html);

        if (mode === 'list') {
            $modal_matching_search.attr('data-employee_help_request_id', employee_help_request_id).modal('show');
        } else if (mode === 'search') {
            $modal_search_organization.modal('hide');
        }
    })
    .catch(err => {
        console.log(err);
        alert(err);
    })
    .finally(() => {
        obj.html(btn_html);
        $btn.prop('disabled', false);
    })
};
